/* eslint-disable no-unused-vars */
import MyraAudioMonitor from "./myraAudioMonitor";
import PcmMediaRecorder from "./PcmMic";
import ResourceManager from "../resource-manager/resource-manager";

// VoiceService.js
const VoiceService = {
  // --- Private State ---
  _ws: null,
  _mediaRecorder: null,
  _isListening: false,
  _isAutoRestart: false,
  _isAutoRestartTimer: false,
  _pendingAudioUrls: [], // Blob URLs waiting to be played until audio is unlocked
  _isPlayingLegacy: false, // only used for non-PCM (blob-URL) fallback
  _awaitingPcmFinish: false,
  _debugChunkCount: 0, // DEBUG: count mic chunks to verify flow
  _pcmBuffer: null,

  _listenersBound: false,
  _listenTimeoutId: null,
  _listenTimeoutMs: 920_000,
  _currentFlow: null,
  _currentFlowStopListen: null,
  _isInitialized: false,
  _intentionalClose: false,
  _connectionMonitor: null,
  _qnaFlows: ["flow_plan_v2", "flow_landing_page", "flow_post_session_qa", "flow_gsa"],
  _hasConnectedBefore: false,
  _updateQNAStatus: false,
  _processingNow: false,
  _updateQNAStatusTimer: null,
  _emptyChunkCount: 0, // state for zombie chunk detection if 5 then restart listening
  _connectionStartTime: null,

  _lastReceivedId: null,
  _lastCallTime: 0,

  _lastTranscriptAt: null,
  _lastTranscriptText: "",
  _waitingForFirstChunk: false,
  _firstChunkTimeout: null,
  // Authoritative agent speaking state
  _isAgentSpeaking: false,
  _agentSpeakingStartTime: null,
  _lastAgentSpeakingCheck: 0,
  _shouldSendAudioData: true, // Control whether to send chunks to backend
  _listeningHealth: {
    lastHealthyCheck: Date.now(),
    consecutiveFailures: 0,
    isRecovering: false
  },
  _bufferOverflowState: {
    isOverflowing: false,
    overflowStartTime: 0,
    totalOverflowDuration: 0,
    chunksDropped: 0,
    tier: 0, // 0=normal, 1=warning, 2=critical, 3=restart
    lastActionTime: 0
  },
  // states for dosay callback track
  _pendingDoSayCallback: null,
  _videoPausedByTTS: false,
  _wasVideoPlaying: false,

  _activeTtsSession: null,
  resetStatus: false, // so when user send transcript less than or equal to 3 then it will get stuck in the thinking states this is used to updated back to normal state

  _callbacks: {
    onNluResult: () => { },
    onAgentSpeechStart: () => { },
    onAgentSpeechEnd: () => { },
    onAgentSpeechEndCustom: () => { },
    onListeningStart: () => { },
    onListeningStop: () => { },
    onAudioReady: () => { }, // fired when app/user has unlocked audioPlayer
    onConnected: () => { },
  },

  // --- Reconnect/heartbeat state (minimal additions) ---
  _url: null,
  _reconnectAttempts: 0,
  _shouldReconnect: true,
  _connecting: false,
  _connected: false,
  _heartbeatTimer: null,
  _pongTimer: null,
  _pingIntervalMs: 15_000,
  _pongTimeoutMs: 45_000,
  _maxBackoffMs: 30_000,

  _deepgramReady: false,

  _visibilityHandler: null,
  _onlineHandler: null,

  // resource-manager
  // _resourceManager: null,
  // _initResourceManagerCalled: false,

  initialize(callbacks = {}) {
    this._intentionalClose = false;
    this._shouldReconnect = true;
    this._isInitialized = true;
    this._retryState = {
      attempts: 0,
      lastAttempt: 0,
      maxAttempts: 999
    };
    this._startListeningInProgress = false;

    // resource manager
    // this.initResourceManager();

    // if (this._ws || this._connecting) {
    //   console.warn("VoiceService is already initialized.");
    //   return;
    // }
    this._callbacks = { ...this._callbacks, ...callbacks };

    if (!this._visibilityHandler) {
      this._visibilityHandler = () => {
        if (document.visibilityState === "visible") {
          this.handleVisibilityRestored();
        }
      };
    }

    if (!this._onlineHandler) {
      this._onlineHandler = () => {
        this._maybeReconnect("online");
      };
    }



    if (window.audioPlayer?.unlocked) {
      this._callbacks.onAudioReady();
    }

    var mainWSSServer = "wss://api.virdiohealth.com/ws/tts";
    if (window.location.host !== "www.startfreept.com" && window.location.host !== "startfreept.com" && window.location.host != "virdiohealth.com" && window.location.host != "www.virdiohealth.com") {
      mainWSSServer = "wss://uatapi.virdiohealth.com/ws/tts";
    }

    // this._url = "ws://localhost:8080/ws/tts";
    this._url = mainWSSServer;
    if (!this._listenersBound) {
      window.addEventListener("online", () => {
        this._connecting = false;
        this._connected = false;
        this.forceReconnect();
      });
      window.addEventListener("offline", () => {
        this._connected = false;
      });
      document.addEventListener("visibilitychange", this._visibilityHandler);
      window.addEventListener("focus", () => {
        if (window.audioPlayer && window.audioPlayer.ctx) { window.audioPlayer.ctx.resume().catch(() => { }); }
        setTimeout(() => this._maybeReconnect(), 500);
      });
      this._listenersBound = true;
    }

    this._connect();
    if (this._zombieCheckInterval) clearInterval(this._zombieCheckInterval);
    this._zombieCheckInterval = setInterval(() => {
      if (!this._isListening && !this._listeningHealth.isRecovering) {
        return; // Nothing to check
      }
      const health = this._isActuallyListening();
      const timeSinceLastHealthy = Date.now() - this._listeningHealth.lastHealthyCheck;
      const isDefinitelyUnhealthy = (health.isZombie || !health.healthy) && timeSinceLastHealthy > 15000;
      if (isDefinitelyUnhealthy) {
        console.error("[ZOMBIE CHECK] Definitely unhealthy:", {
          health,
          timeSinceLastHealthy: Math.round(timeSinceLastHealthy / 1000) + 's',
          consecutiveFailures: this._listeningHealth.consecutiveFailures
        });
        this._forceRestartListening();
      } else if (health.healthy) {
        this._listeningHealth.consecutiveFailures = 0;
        this._listeningHealth.lastHealthyCheck = Date.now();
      }

    }, 30000);
  },
  // initResourceManager(callbacks = {}) {
  //   if (this._initResourceManagerCalled) return;
  //   this._initResourceManagerCalled = true;

  //   this._resourceManager = new ResourceManager({
  //     onWarning: (stage, data) => {

  //       const userMessage = this._resourceManager.getUserMessage();
  //       console.log(`[Resource Manager onWarning : ] ${data}`)
  //       if (!userMessage) return;

  //       document.dispatchEvent(new CustomEvent('resource:warning', {
  //         detail: {
  //           message: userMessage.body || 'Optimizing for smoother performance...',
  //           title: userMessage.title,
  //           severity: userMessage.severity,
  //           type: userMessage.type,
  //           data: { ...data, flow: this._currentFlow }
  //         }
  //       }));

  //       if (!this._isListening && this._ws?.readyState === WebSocket.OPEN) {
  //         setTimeout(() => this._startListening().catch(() => { }), 1000);
  //       }
  //     },

  //     onCritical: (stage, data) => {

  //       const userMessage = this._resourceManager.getUserMessage();
  //       console.log(`[Resource Manager onCritical : ] ${data}`)

  //       document.dispatchEvent(new CustomEvent('resource:critical', {
  //         detail: {
  //           message: userMessage?.body || 'Adjusting settings for stability...',
  //           title: userMessage?.title || 'Stability Issue',
  //           severity: 'critical',
  //           requiresAction: true,
  //           data: { ...data, flow: this._currentFlow }
  //         }
  //       }));

  //       this.forceStop();
  //       setTimeout(() => {
  //         if (!this._intentionalClose && this._shouldReconnect) {
  //           this.forceReconnect();
  //           setTimeout(() => {
  //             if (this._currentFlow && !this._isListening && this._ws?.readyState === WebSocket.OPEN) {
  //               this._startListening().catch(() => { });
  //             }
  //           }, 3000);
  //         }
  //       }, 1500);
  //     },

  //     onRecovered: (data) => {
  //       const recoveryMsg = this._resourceManager.recovery?.getRecoveryMessage?.(data);
  //       console.log(`[Resource Manager OnRecovery : ] ${data}`)

  //       document.dispatchEvent(new CustomEvent('resource:recovery', {
  //         detail: {
  //           message: recoveryMsg?.body || 'Resuming your session...',
  //           title: recoveryMsg?.title || 'Recovery',
  //           severity: 'info',
  //           data: { ...data, flow: this._currentFlow }
  //         }
  //       }));

  //       this.forceReconnect();
  //       setTimeout(() => {
  //         if (this._currentFlow && !this._isListening && this._ws?.readyState === WebSocket.OPEN) {
  //           this._startListening().catch(() => { });
  //         }
  //       }, 3000);
  //     }
  //   });

  //   this._resourceManager.initialize().then(assessment => {
  //     if (assessment.requiresAction) {
  //       const userMessage = this._resourceManager.getUserMessage();
  //       if (userMessage) {
  //         document.dispatchEvent(new CustomEvent('resource:warning', {
  //           detail: {
  //             message: userMessage.body || assessment.recommendation.message,
  //             title: userMessage.title,
  //             severity: 'info',
  //             type: 'initial',
  //             isInitial: true,
  //             data: { assessment, flow: this._currentFlow }
  //           }
  //         }));
  //       }
  //     }
  //   });
  // },

  // updateResourceIndicator() {
  //   // Find the mic button - use various possible selectors
  //   const micButton = document.querySelector('.micButton') ||
  //     document.querySelector('[title*="Voice Assistant"]') ||
  //     document.querySelector('button svg[aria-hidden="true"]')?.closest('button');

  //   if (micButton && !document.querySelector('.resourceIndicator')) {
  //     // Ensure mic button container has relative positioning
  //     if (micButton.parentNode && micButton.parentNode.style.position !== 'relative') {
  //       micButton.parentNode.style.position = 'relative';
  //     }

  //     const indicator = document.createElement('div');
  //     indicator.className = 'resourceIndicator';
  //     indicator.title = 'Performance optimization active';

  //     micButton.parentNode.appendChild(indicator);

  //     // Auto-remove indicator after 10 seconds
  //     setTimeout(() => {
  //       if (indicator.parentNode) {
  //         indicator.remove();
  //       }
  //     }, 10000);
  //   }
  // },
  notifyAudioReady() {
    this._callbacks.onAudioReady();
    this._flushPendingBlobUrls();
  },
  _ensureWebSocketReady() {
    if (this._intentionalClose) {
      console.log("[ENSURE_WS] Overriding intentional close for connection");
      this._intentionalClose = false;
      this._shouldReconnect = true;
    }
    if (!this._ws || this._ws.readyState !== WebSocket.OPEN) {
      console.warn("[WS] WebSocket not ready, state:", this._ws?.readyState);
      return false;
    }
    return true;
  },
  _isQnAFlow() {
    return this._qnaFlows.includes(this._currentFlow);
  },
  sendQNADataToBackend(qnaData) {
    if (!this._ensureWebSocketReady()) {
      console.error("WebSocket not connected. Cannot send QnA data.");
      return false;
    }
    let sessionId = window.trSessionId || localStorage.getItem("trSessionId");

    this._ws.send(
      JSON.stringify({
        type: "qna_data",
        data: qnaData,
        sessionId: sessionId,
        uniqueId: this._generateUniqueId()
      })
    );
    return true;
  },
  proceedToRecoveryPlan(dynamicSpeech, serviceSwitch = "gemini", qnaData = null) {
    if (window.audioPlayer) {
      try {
        window.audioPlayer.stopAudio();
        window.audioPlayer.ttsPcmAbort();
        window.audioPlayer._pcmRemainder = new Uint8Array(0);

        // Reset PCM state completely
        window.audioPlayer.pcm = {
          active: false,
          sampleRate: 24000,
          scheduleTime: 0,
          sources: new Set(),
          queuedSamples: 0,
          floatQueue: [],
          floatQueueSamples: 0,
          minBufferSec: 0.5,
          endReceived: false
        };
      } catch (e) {
        console.error("[FLOW_PLAN_V2] Error resetting audioPlayer:", e);
      }
    }
    this.stopAllVoiceActivity();
    if (!this._ensureWebSocketReady()) {
      console.error("WebSocket is not connected. Cannot proceed to recovery plan.");
      return false;
    }
    if (qnaData) {
      this.sendQNADataToBackend(qnaData);
    }
    window.currentFlow = "flow_plan_v2"
    this._currentFlow = "flow_plan_v2"

    this._ws.send(
      JSON.stringify({
        type: "start_flow",
        flow: "flow_plan_v2",
        speech: dynamicSpeech,
        switch: serviceSwitch
      })
    );
    return true;
  },
  updateRational(text) {
    try {
      const userName = window.localStorage.getItem("self_name") || "";

      if (VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        VoiceService._ws.send(JSON.stringify({ type: "update_rational", text: text, name: userName }));
        console.log("Sent speech command to backend");
      } else {
        console.warn("WebSocket not connected - cannot send speech command");
      }
    } catch (error) {
      console.error("Error sending speech command:", error);
    }
  },
  sendMidJourneyData(data = null, initialScreenSpeech = "") {
    if (!this._ensureWebSocketReady()) {
      console.error("WebSocket is not connected. Cannot proceed to recovery plan.");
      return false;
    }
    this._ws.send(
      JSON.stringify({
        type: "midjourney_data",
        data: data,
        midjourneyData: data,
        screen: initialScreenSpeech || ""
      })
    );
    return true;
  },
  updateTouchPointandSessionId(touchpoint, sessionId) {
    if (!this._ensureWebSocketReady()) {
      console.error("WebSocket is not connected. Cannot proceed to recovery plan.");
      return false;
    }
    if (!touchpoint || !sessionId) {
      console.error("can not update the session id or touchpoint as they are null");
      return false;
    }
    this._ws.send(
      JSON.stringify({
        type: "updateTouchPointandSessionId",
        touchpoint: touchpoint,
        sessionId: sessionId,
        uniqueId: this._generateUniqueId()
      })
    );
    return true;
  },
  sendPostQA(dataSend) {
    this._ws.send(
      JSON.stringify({
        type: "postSessionQNA_data",
        data: dataSend,
        uniqueId: this._generateUniqueId()
      })
    );
    return true;
  },
  _isActuallyListening() {
    if (!this._mediaRecorder) {
      const wsOpen = this._ws?.readyState === WebSocket.OPEN;
      // Sync flag with reality
      if (this._isListening) {
        console.warn(`[STATE SYNC] No media recorder but _isListening=true, correcting to false`);
        this._isListening = false;
        if (this._callbacks.onListeningStop) {
          this._callbacks.onListeningStop();
        }
      }
      return {
        healthy: false,
        isRecorderActive: false,
        isStreamHealthy: false,
        wsOpen: wsOpen,
        isZombie: false
      };
    }
    const isRecorderActive = this._mediaRecorder.state === "recording";
    const stream = this._mediaRecorder.stream;
    // If recorder says it's recording but we don't have a stream, it's a zombie
    if (isRecorderActive && !stream) {
      if (this._isListening) {
        console.warn(`[STATE SYNC] Zombie state: recorder active but no stream, correcting flag`);
        this._isListening = false;
        if (this._callbacks.onListeningStop) {
          this._callbacks.onListeningStop();
        }
      }
      return {
        healthy: false,
        isRecorderActive: true,
        isStreamHealthy: false,
        wsOpen: this._ws?.readyState === WebSocket.OPEN,
        isZombie: true
      };
    }
    let isStreamHealthy = false;
    if (stream) {
      const tracks = stream.getAudioTracks();
      const hasLiveTracks = tracks.length > 0 && tracks.some(t => t.readyState === 'live');
      const allTracksEnabled = tracks.every(t => t.enabled);
      isStreamHealthy = stream.active && hasLiveTracks && allTracksEnabled;
    }
    const wsOpen = this._ws?.readyState === WebSocket.OPEN;
    const healthy = isRecorderActive && isStreamHealthy && wsOpen;
    const isZombie = isRecorderActive && (!isStreamHealthy || !wsOpen);
    if (this._isListening !== healthy) {
      console.warn(`[STATE SYNC] Correcting isListening flag: ${this._isListening} -> ${healthy}`);
      this._isListening = healthy;
      if (healthy && this._callbacks.onListeningStart) {
        console.log(`[STATE SYNC] Triggering onListeningStart callback`);
        this._callbacks.onListeningStart();
      } else if (!healthy && this._callbacks.onListeningStop) {
        console.log(`[STATE SYNC] Triggering onListeningStop callback`);
        this._callbacks.onListeningStop();
      }
    }
    return {
      healthy,
      isRecorderActive,
      isStreamHealthy,
      wsOpen,
      isZombie
    };
  },
  getListeningHealth() {
    const health = this._isActuallyListening();
    const timeSinceLastHealthy = Date.now() - this._listeningHealth.lastHealthyCheck;

    return {
      isListening: this._isListening,
      shouldSendAudio: this._shouldSendAudioData,
      isAgentSpeaking: this._isAgentSpeaking,
      health: health,
      timeSinceLastHealthy: Math.round(timeSinceLastHealthy / 1000),
      consecutiveFailures: this._listeningHealth.consecutiveFailures,
      isRecovering: this._listeningHealth.isRecovering,
      mediaRecorderState: this._mediaRecorder?.state,
      websocketState: this._ws?.readyState,
      deepgramConnected: this._deepgramConnected
    };
  },
  startFlow(flow, userName, announcement = "") {
    // Clearing previous transcripts from bubble when new flow starts
    const debugEl = document.getElementById("debugVoice");
    if (debugEl) {
      debugEl.innerHTML = "";
    }
    // calling clearing condition when starting flow (it will check if the condition is 30 mins old then it will removed it)
    // this._checkAndClearExpiredConditions();

    this._isAgentSpeaking = false;
    this._agentSpeakingStartTime = null;
    // resetting the overflow states:
    if (this._bufferOverflowState.isOverflowing) {
      this._resetOverflowState();
    }
    if (window.audioPlayer && window.audioPlayer.pcm) {
      // Stoping the any ongoing PCM playback
      if (typeof window.audioPlayer.ttsPcmAbort === 'function') {
        window.audioPlayer.ttsPcmAbort();
      }
      // Force reset state
      window.audioPlayer.pcm.active = false;
      window.audioPlayer.pcm.queuedSamples = 0;
      window.audioPlayer.pcm.endReceived = false;
      window.audioPlayer.pcm.floatQueue = [];
      window.audioPlayer.pcm.floatQueueSamples = 0;
      window.audioPlayer.pcm.sources.clear();
    }
    this._pcmBuffer = null;
    this._cachedStream = null;

    if (!this._ensureWebSocketReady()) {
      console.error("WebSocket is not connected. Cannot start flow.");
      // FIX: Attempt reconnection
      this._connect();
      return;
    }

    let sessionId = window.trSessionId || localStorage.getItem("trSessionId");
    this._cachedStream = null;

    let runCommands = { type: "start_flow", startName: userName, sessionId: sessionId, flow, announcement, isSecondStart: !!window.manuallyDisabledOnce, sourceSite: window.location.host.replace('www.', '').replace('.com', '') };
    if (window.mayraForwardCode) {
      runCommands = { ...runCommands, ...window.mayraForwardCode };
      window.mayraForwardCode = undefined;
    }
    // const isMac = /Mac/.test(navigator.platform);
    // const delay = isMac ? 1200 : 500;
    // if (!this._isActuallyListening().healthy) {
    //   setTimeout(() => {
    //     this._startListening()
    //   }, delay);
    // }
    const health = this._isActuallyListening();

    if (health.healthy) {
      console.log("Starting flow (mic already active)", runCommands);
      this._ws.send(JSON.stringify(runCommands));
      this._currentFlow = flow;
      window.currentFlow = flow;
    } else {
      this._startListening()
        .then(() => {
          this._ws.send(JSON.stringify(runCommands));
          this._currentFlow = flow;
          window.currentFlow = flow;
        })
        .catch(err => {
          console.log("Starting flow despite mic failure", runCommands);
          this._ws.send(JSON.stringify(runCommands));
          this._currentFlow = flow;
          window.currentFlow = flow;
        });
    }
    // console.log("Starting flow", runCommands);
    // this._ws.send(JSON.stringify(runCommands));
    // this._currentFlow = flow;
    // window.currentFlow = flow;
  },

  close() {
    // NEW: prevent auto-reconnect on intentional close
    this._intentionalClose = true;
    this._shouldReconnect = false;

    this._stopListening();
    if (this._ws) this._ws.close();
    // if (this._resourceManager) {
    //   this._resourceManager.shutdown({
    //     mediaRecorder: this._mediaRecorder,
    //     audioContext: window.audioPlayer?.context,
    //     videoStream: this._cachedStream
    //   });
    // }
    this._cleanup();
    if (this._connectionMonitor) {
      clearInterval(this._connectionMonitor);
      this._connectionMonitor = null;
    }
  },

  // --- Private ---

  async _handleBackendMessage(event) {
    // Any message counts as activity; bump pong timer for heartbeat
    this._bumpPongTimer();

    // STEP 4: NOTIFY WHEN AUDIO RECEIVED (for WebSocket commands)
    if (this._audioMonitor) {
      this._audioMonitor.notifyAudioDataReceived();
    }

    // --- Replace inside _handleBackendMessage ---
    if (event.data instanceof ArrayBuffer) {

      const buffer = event.data;

      // Must be at least 4 bytes for session header
      if (buffer.byteLength < 4) return;

      const view = new DataView(buffer);

      // First 4 bytes = session ID (big-endian)
      const incomingSession = view.getUint32(0);

      // console.log('Income session', incomingSession, this._activeTtsSession);

      // Drop stale audio immediately
      if (incomingSession !== this._activeTtsSession) {
        return;
      }

      // Remaining bytes = raw PCM
      const pcmData = buffer.slice(4);
      const buf = new Uint8Array(pcmData);
      if (!this._totalPcmBytes) {
        this._totalPcmBytes = 0
      }
      this._totalPcmBytes += buf.length

      // Update audioPlayer byte counter for completion verification
      if (window.audioPlayer?.pcm) {
        window.audioPlayer.pcm.totalReceivedBytes += buf.length;
      }
      // console.log(`[PCM RECEIVED] Chunk: ${buf.length} bytes, Total: ${this._totalPcmBytes} bytes`)

      if (this._updateQNAStatus === true) {
        if (this._updateQNAStatusTimer) clearTimeout(this._updateQNAStatusTimer);
        this._updateQNAStatusTimer = setTimeout(() => {
          this._updateQNAStatus = false;
          console.log("[QNA STATUS] Reset status after delay");
        }, 1500);
      }

      if (!this._firstAudioChunkReceived && buf.length > 0) {
        this._firstAudioChunkReceived = true;
        console.log("[MAC FIX] First audio chunk received");
      }

      // Accumulate into buffer
      if (!this._pcmBuffer) this._pcmBuffer = new Uint8Array(0);

      const merged = new Uint8Array(this._pcmBuffer.length + buf.length);
      merged.set(this._pcmBuffer, 0);
      merged.set(buf, this._pcmBuffer.length);
      this._pcmBuffer = merged;

      // Process only full 2-byte frames
      const usableLength = this._pcmBuffer.length - (this._pcmBuffer.length % 2);

      if (usableLength > 0) {

        const toSend = this._pcmBuffer.slice(0, usableLength);

        try {
          if (window.audioPlayer?.ctx?.state === 'suspended') {
            window.audioPlayer.ctx.resume().then(() => {
              // if (this._currentFlow === "flow_plan_v2") {
              //   window.audioPlayer.ttsPcmPushForFlowPlanV2(toSend.buffer);
              // } else {
              // }
              if (incomingSession === this._activeTtsSession) {
                window.audioPlayer.ttsPcmPush(toSend.buffer);
              }
            }).catch(err => {
              console.error("[PCM] Resume failed, audio might be lost:", err);
            });
          } else {
            // window.audioPlayer.ttsPcmPush(toSend.buffer);
            // if (this._currentFlow === "flow_plan_v2") {
            //   window.audioPlayer.ttsPcmPushForFlowPlanV2(toSend.buffer);
            // } else {
            // }
            window.audioPlayer.ttsPcmPush(toSend.buffer);
          }
        } catch (e) {
          console.error("PCM push failed:", e);
        }
        // keep leftover bytes (at most 1 byte)
        this._pcmBuffer = this._pcmBuffer.slice(usableLength);
      }
      return;
    }

    try {
      const command = JSON.parse(event.data);
      console.log("Got command", command);

      // STEP 4: NOTIFY WHEN AUDIO RECEIVED (for WebSocket commands)
      if (this._audioMonitor && command.type === "tts_listening") {
        this._audioMonitor.notifyAudioDataReceived();
      }

      this._handleBackendCommand(command);
    } catch (error) {
      console.error(error);
      console.error("Received non-JSON message:", event.data);
    }
  },
  resumeCompletely() {
    this._intentionalClose = false;
    const health = this._isActuallyListening();
    if (health.healthy) {
      console.log("[SAFE_RESUME] Already listening, skipping");
      return Promise.resolve();
    }
    if (!this._ws || this._ws.readyState !== WebSocket.OPEN) {
      return new Promise((resolve) => {
        this._connect();

        // Wait for connection
        const checkConnection = () => {
          if (this._ws?.readyState === WebSocket.OPEN) {
            setTimeout(() => {
              this._startListening().then(resolve).catch(resolve);
            }, 1000);
          } else {
            setTimeout(checkConnection, 100);
          }
        };
        checkConnection();
      });
    }
    return this._startListening().catch(error => {
      console.error("[SAFE_RESUME] Failed to start listening:", error);
      throw error;
    });
  },
  stopCompletely() {
    console.log("[VoiceService] Stopping completely...");
    try {
      this.stopAgentSpeech();
      this._stopListening();
      this._isListening = false;
    } catch (err) {
      console.error("[VoiceService] Error while stopping:", err);
    }
  },
  getConnectionStatus() {
    const userName = localStorage.getItem("self_name") || ""
    const listeningHealth = this._isActuallyListening();


    if (this._isListening && !listeningHealth?.healthy) {
      return 'listening_error';
    }
    if (!this._url && !this._ws && !this._connecting && !this._isInitialized) {
      return 'not_initialized';
    }
    // if (this._ws?.readyState === WebSocket.OPEN && !this._deepgramReady) {
    //   const waitTime = Date.now() - (this._connectionStartTime || 0);
    //   if (waitTime > 10000) {
    //     // Been waiting 10+ seconds - likely stuck
    //     console.warn('[CONNECTION STATUS] Deepgram not ready after 10s, may be stuck');
    //     return 'reconnecting';
    //   }
    //   return 'reconnecting';
    // }

    // If we're in the process of connecting
    if (this._connecting) {
      window.updateTextScreen({ USERNAME: userName, WEBSOCKET_STATUS: 'reconnecting' });
      const connectingTime = Date.now() - (this._connectionStartTime || 0);
      if (connectingTime > 15000) {
        setTimeout(() => {
          this.forceReconnect();
        }, 300);
      }
      return 'reconnecting';
    }
    // Check WebSocket state
    if (!this._ws) {
      window.updateTextScreen({ USERNAME: userName, WEBSOCKET_STATUS: 'disconnected' });
      return 'disconnected';
    }

    if (this._processingNow) {
      return 'Preparing_Response';
    }
    if (this.resetStatus) {
      this.resetStatus = false;
      return 'Reset_Status'
    }

    if (this._transcript) {
      return 'Processing_Question';
    }

    if (window.forcedStatusMyra) {
      return 'Forced_Status';
    }

    const wsState = this._ws.readyState;

    // Map WebSocket states to our connection status
    const stateMap = {
      [WebSocket.CONNECTING]: 'reconnecting',
      [WebSocket.OPEN]: 'connected',
      [WebSocket.CLOSING]: 'disconnected',
      [WebSocket.CLOSED]: 'disconnected'
    };

    return stateMap[wsState] || 'disconnected';
  },
  resetAssembly() {
    if (this._ws && this._ws.readyState === WebSocket.OPEN) {
      this._ws.send(JSON.stringify({
        type: "reset_assembly",
        flow: this._currentFlow,
        uniqueId: this._generateUniqueId()
      }));
    }
  },
  // _checkAndClearExpiredConditions() {
  //   const CONDITION_EXPIRY_MS = 30 * 60 * 1000; // 30 minutes in milliseconds
  //   const userCondition = JSON.parse(localStorage.getItem("userCondition") || "{}");
  //   if (userCondition.timestamp) {
  //     if (Date.now() - userCondition.timestamp > CONDITION_EXPIRY_MS) {
  //       localStorage.removeItem("userCondition");
  //       console.log("[CONDITION] User condition expired and cleared");
  //     }
  //   }
  // },


  _handleBackendCommand(command) {
    if (command.uniqueId && this._lastReceivedId === command.uniqueId) {
      console.log("Disable same commands");
      return;
    }

    if (command.type === "pong") {
      console.log("PONG RECEIVED");
      return;
    }
    if (command.type === "UPDATE_STATUS") {
      console.log("got the status")
      this._updateQNAStatus = true
    }

    if (command.type === "UPDATE_PROCESSING") {
      console.log("got the status processing")
      this._processingNow = true;
      if (window.forceStatusUpdate) { window.forceStatusUpdate(); }
    }

    if (command.type === "TRANSCRIPT_RECEIVED") {
      console.log("got the status")
      this._transcript = true
    }

    // Step 5: Notify monitor of Deepgram status changes
    if (command.type === "deepgram_connected" && this._audioMonitor) {
      if (!this._deepgramReady) {
        console.log("[DEEPGRAM] Connected");
        this._deepgramReady = true;
        this._deepgramConnected = true;
        this._audioMonitor.notifyDeepgramStatus(true);
      }
      this._audioMonitor.notifyDeepgramStatus(true);
    } else if (command.type === "deepgram_disconnected" && this._audioMonitor) {
      if (this._deepgramReady) {
        console.log("[DEEPGRAM] Disconnected");
        this._deepgramReady = false;
        this._deepgramConnected = false;
        this._audioMonitor.notifyDeepgramStatus(false);
      }
      // if (this._isListening && this._mediaRecorder?.state === "recording") {
      //   setTimeout(() => {
      //     if (this._deepgramConnected === false && this._ws?.readyState === WebSocket.OPEN) {
      //       this._ws.send(JSON.stringify({
      //         type: "restart_deepgram",
      //         timestamp: Date.now(),
      //         reason: "deepgram_disconnected_event"
      //       }));
      //     }
      //   }, 5000);
      // }
    }

    this._lastReceivedId = command.uniqueId;

    if (command.type === "pause_for_confirmation") {
      // Pause video during confirmation
      if (window.videoController) {
        window.videoController.pause();
      }

      // Visual indicator (optional)
      if (this._callbacks.onConfirmationNeeded) {
        this._callbacks.onConfirmationNeeded();
      }
    }

    if (command.type === "nlu_result") {
      // updating fileds for userMidJourneyData payload
      if (this._currentFlow === "flow_landing_page") {
        window.landingMessageCount = (window.landingMessageCount || 0) + 1;

        if (command.data && command.data.intent) {
          if (window.landingTopic) {
            // Appending new intent
            window.landingTopic = `${window.landingTopic}, ${command.data.intent}`;
          } else {
            // First intent
            window.landingTopic = command.data.intent;
          }
        }
      }
      if (this._currentFlow === "flow_gsa") {
        window.myraEngagedGsa = true;
        window.gsaMessageCount = (window.gsaMessageCount || 0) + 1;
        if (command.data && command.data.intent) {
          if (window.flowGsaTopic) {
            // Appending new intent
            window.flowGsaTopic = `${window.flowGsaTopic}, ${command.data.intent}`;
          } else {
            // First intent
            window.flowGsaTopic = command.data.intent;
          }
        }
      }
      if (this._currentFlow === "flow_plan_v2") {
        window.planV2MessageCount = (window.planV2MessageCount || 0) + 1;
        window.myraEngagedPlanV2 = true;
        if (command.data && command.data.intent) {
          if (window.planV2Topic) {
            // Appending new intent
            window.planV2Topic = `${window.planV2Topic}, ${command.data.intent}`;
          } else {
            // First intent
            window.planV2Topic = command.data.intent;
          }
        }
      }
      this._processingNow = false;
      this.resetStatus = false;
      if (window.forceStatusUpdate) { window.forceStatusUpdate(); }
      // Clear the transcription from the banner when command is executed
      if (document.getElementById("debugVoice")) {
        document.getElementById("debugVoice").innerHTML = "";
      }
      if (window.sendtobackend) {
        window.sendtobackend = false;
        console.log("[DEBUG] Backend started processing, reset sendtobackend = false");
      }
      if (command.data && (command.data.action === "MOVE_ON" || command.data.intent === "continue_command")) {
        console.log(["Resetting assembly triggers"])
        this.resetAssembly()
      }
      if (command.data.action === "AUTO_PAUSE" && command.data.value === true) {
        let skippedFlows = ["flow_plan_v2", "flow_landing_page", "flow_post_session_qa"]
        if (skippedFlows.includes(this._currentFlow)) {
          console.log("[INACTIVITY] Auto-pause detected - SKIPPING AUTO PAUSE FOR QNA FLOWS");
          return;
        }

        console.log("[INACTIVITY] Auto-pause detected - showing modal");
        if (window.mayraCode) {
          const isEnabled = window.mayraCode.isEnabled ? true : false;
          const isVisible = window.mayraCode.isVisible ? true : false;
          if (isEnabled && isVisible) {
            window.mayraCode.doSay("I’ve paused. Take your time. Press the re-zume button when you’re ready.", () => {
              // Dispatch event
              document.dispatchEvent(
                new CustomEvent("showInactivityModal", {
                  detail: { reason: "inactivity_timeout" },
                })
              );
              setTimeout(() => {
                this.stopCompletely();
              }, 500);
            });
          }
        }
      }
      if (command.data && command.data.intent === "condition_disclosure" && command.data?.conditions) {
        const formattedConditions = {
          pre_existing: command.data.conditions.pre_existing,
          current: command.data.conditions.current
        };

        // Convert pre_existing to string if it's an array
        if (Array.isArray(formattedConditions.pre_existing)) {
          formattedConditions.pre_existing = formattedConditions.pre_existing.join(", ");
        }

        // Ensure current is string
        if (Array.isArray(formattedConditions.current)) {
          formattedConditions.current = formattedConditions.current.join(", ");
        }

        const userCondition = {
          usercondition: formattedConditions,
          timestamp: Date.now()
        };
        localStorage.setItem("userCondition", JSON.stringify(userCondition));

        const assessmentData = JSON.parse(localStorage.getItem("assessmentData") || "{}");

        // Create biometrics if it doesn't exist
        if (!assessmentData.biometrics) {
          assessmentData.biometrics = {};
        }
        // Handle current conditions (append if exists)
        if (formattedConditions.current) {
          if (assessmentData.biometrics.currentConditions) {
            // Append with comma if both exist
            assessmentData.biometrics.currentConditions =
              assessmentData.biometrics.currentConditions + ", " + formattedConditions.current;
          } else {
            // Set new value
            assessmentData.biometrics.currentConditions = formattedConditions.current;
          }
        }
        if (formattedConditions.pre_existing) {
          if (assessmentData.biometrics.preExistingConditions) {
            // Append with comma if both exist
            assessmentData.biometrics.preExistingConditions =
              assessmentData.biometrics.preExistingConditions + ", " + formattedConditions.pre_existing;
          } else {
            // Set new value
            assessmentData.biometrics.preExistingConditions = formattedConditions.pre_existing;
          }
        }
        localStorage.setItem("assessmentData", JSON.stringify(assessmentData));
      }
      if (command.data.action === "TURN_OFF" && command.data.value === true) {
        console.log("[TURN_OFF] Global turn-off command received - stopping all voice activity");
        if (window.mayraCode) {
          window.mayraCode.doSay("I heard you say turn off. I'm turning off now.", () => {
            // this.stopAllVoiceActivity();

            // // Optionally notify the UI that Myra has been turned off
            // if (this._callbacks.onNluResult) {
            //   this._callbacks.onNluResult(command.data);
            // }

            // // Stop listening but keep WebSocket connection alive
            // this._stopListening();

            // // Clear current flow
            // this._currentFlow = null;

            // return;
            this.stopCompletely();
          });
        }
        setTimeout(() => {
          this.stopCompletely();
        }, 5000);
      }
      if (command.speech) {
        // Store the speech for the frontend to use for symptom1 flow
        command.data.customSpeech = command.speech;
      }
      if (command.intent) {
        // Store the intent for the frontend to use for recovery help flow
        command.data.intent = command.intent;
      }
      if (this._currentFlow !== "personalized") {
        // this._stopListening();
      }
      // First try global handler if available
      if (window.currentCommandsAudio && window.currentCommandsAudio[command.data.action]) {
        console.log("Using global command handler for:", command.data.action);
        const now = Date.now();
        if (now - this._lastCallTime > 500) {
          window.currentCommandsAudio[command.data.action](command.data.value, command.data.customSpeech, command.data.intent);
          this._lastCallTime = now;
        } else {
          console.log("Too fast call");
        }
      } else {
        // this._stopListening();
      }

      // Then call the internal callback
      if (this._callbacks.onNluResult) {
        this._callbacks.onNluResult(command.data);
      }
    }
    if (command.type === "RESET_STATUS") {
      this.resetStatus = true;
    }
    if (command.type === "personalized_keep_alive") {
      console.log("[PERSONALIZED] Keep alive received - maintaining microphone");
      // Ensure microphone stays on
      if (!this._isListening) {
        this._startListening();
      }
    }

    if (command.type === "agent_speech") {
      if (this._callbacks.onAgentSpeechStart && command.message !== "") {
        this._callbacks.onAgentSpeechStart();
      }

      this._processingNow = false;
      this.resetStatus = false;
      if (window.forceStatusUpdate) { window.forceStatusUpdate(); }
      console.log("Agent will say:", command.message);
      document.getElementById("debugVoice").innerHTML = "";
    }

    if (command.type === "tts_start") {
      // if (window.videoController) {
      //   this._videoPausedByTTS = true;
      //   window.videoController.pause();
      // }
      if (this._playbackMonitorTimer) {
        clearTimeout(this._playbackMonitorTimer);
        this._playbackMonitorTimer = null;
      }
      this._totalPcmBytes = 0;
      this._expectedPcmBytes = 0; // Will be set by tts_end
      this._ttsEndReceived = false;

      this._activeTtsSession = command.ttsSession;
      this._pcmBuffer = new Uint8Array(0);

      this._wasVideoPlaying = window.videoController ? !window.videoController.isPaused() : false;

      if (window.videoController && this._wasVideoPlaying) {
        window.videoController.pause();
      }
      this._processingNow = false;
      this.resetStatus = false;
      if (window.forceStatusUpdate) { window.forceStatusUpdate(); }

      this._isAgentSpeaking = true;
      this._agentSpeakingStartTime = Date.now();
      try {
        this._transcript = false;
        if (this._updateQNAStatus === true) {
          if (this._updateQNAStatusTimer) { clearTimeout(this._updateQNAStatusTimer); }

          this._updateQNAStatusTimer = setTimeout(() => {
            this._updateQNAStatus = false;
          }, 1500);
          console.log("[QNA STATUS] Clearing preparing status - speaking started");
        }
        if (this._callbacks.onAgentSpeechStart) {
          this._callbacks.onAgentSpeechStart();
        }
        if (window?.audioPlayer) {
          console.log("[TTS_CONTEXT] => ", window.audioPlayer?.ctx?.state)
        }
        if (window.audioPlayer?.ctx?.state === "suspended") {
          console.log("[TTS_START] Resuming suspended AudioContext");
          window.audioPlayer.ctx.resume().then(() => {
            console.log("[TTS_START] AudioContext resumed successfully");
          }).catch(err => {
            console.error("[TTS_START] Failed to resume AudioContext:", err);
          });
        }
        const sr = command.sampleRate || 24000;
        if (window.audioPlayer?.ttsPcmStart) window.audioPlayer.ttsPcmStart(sr);

        if (this._currentFlow === "help" && window.stopStartAudio && window.stopLightAudio) {
          window.stopStartAudio();
          window.stopLightAudio();
        }

      } catch (e) {
        console.warn("tts_start handling failed:", e);
      }

      // this._startListening();
    }

    if (command.type === "tts_listening") {
      if (command.transcript && document.getElementById("debugVoice")) document.getElementById("debugVoice").innerHTML = command.transcript;
      // if (command.transcript && document.getElementById("customTextDebug")) document.getElementById("customTextDebug").innerHTML = command.transcript;

      if (this._lastTranscriptText != command.transcript) {
        this._lastTranscriptAt = Date.now();
        this._lastTranscriptTime = Date.now();
        this._lastTranscriptText = command.transcript;
      }
    }

    if (command.type === "tts_end") {
      this._ttsEndReceived = true;
      this._expectedPcmBytes = command.totalBytes || this._totalPcmBytes;

      console.log(`[TTS END] Received - Expected: ${this._expectedPcmBytes}, Got: ${this._totalPcmBytes}`);
      if (window.audioPlayer?.ttsPcmEnd) {
        window.audioPlayer.ttsPcmEnd(command.totalBytes || 0);
        console.log("[TTS END] Called ttsPcmEnd with totalBytes:", command.totalBytes || 0);
      }
      this._awaitPcmFinish();
    }

    if (command.type === "tts_error") {
      this._isAgentSpeaking = false;
      this._agentSpeakingStartTime = null;
      console.warn("TTS backend error:", command.message);
      try {
        if (window.audioPlayer?.ttsPcmAbort) window.audioPlayer.ttsPcmAbort();
      } catch (_) { }
      if (this._callbacks.onAgentSpeechEnd) {
        this._callbacks.onAgentSpeechEnd();
      }
      if (this._callbacks.onAgentSpeechEndCustom) {
        this._callbacks.onAgentSpeechEndCustom();
      }
      this._startListening();
    }
  },
  getSilenceDurationMs() {
    if (!this._lastTranscriptAt) return 0;
    return Date.now() - this._lastTranscriptAt;
  },
  _awaitPcmFinish() {
    if (this._awaitingPcmFinish) return;
    this._awaitingPcmFinish = true;
    const isQnAFlow = this._isQnAFlow();


    const poll = () => {
      if (!this._awaitingPcmFinish) {
        return;
      }

      const active = !!window.audioPlayer?.pcm?.active;
      const queued = window.audioPlayer?.pcm?.queuedSamples || 0;
      const hasPendingFloat = window.audioPlayer?.pcm?.floatQueueSamples > 0;

      // Byte verification: if we know expected bytes, don't declare complete until they match
      const expectedBytes = this._expectedPcmBytes || 0;
      const receivedBytes = this._totalPcmBytes || 0;
      const bytesStillMissing = expectedBytes > 0 && receivedBytes < expectedBytes;

      // Safety valve: if bytes are missing for more than 5 seconds after tts_end, complete anyway
      if (bytesStillMissing && this._ttsEndReceived) {
        if (!this._byteWaitStart) this._byteWaitStart = Date.now();
        const waitedMs = Date.now() - this._byteWaitStart;
        if (waitedMs > 5000) {
          console.warn(`[PCM FINISH] Byte timeout after ${waitedMs}ms - expected: ${expectedBytes}, got: ${receivedBytes}. Completing anyway.`);
          this._byteWaitStart = null;
          // Let it fall through as complete
        }
      } else {
        this._byteWaitStart = null;
      }

      const byteTimeout = this._byteWaitStart && (Date.now() - this._byteWaitStart > 5000);
      const isComplete = !active && queued === 0 && (!bytesStillMissing || byteTimeout);

      if (isComplete) {
        this._isAgentSpeaking = false;
        this._agentSpeakingStartTime = null;
        // if (this._currentFlow !== "flow_get_name" && window?.videoController &&
        //   this._videoPausedByTTS) {
        //   window.videoController.play();
        //   this._videoPausedByTTS = false;
        // }
        if (this._currentFlow !== "flow_get_name" && window?.videoController && this._wasVideoPlaying) {
          window.videoController.play();
          this._wasVideoPlaying = false;
        }
        console.log("Finished playing all PCM audio");
        if (this._pendingDoSayCallback) {
          const callback = this._pendingDoSayCallback;
          this._pendingDoSayCallback = null; // Clear it first
          try {
            console.log("Calling the callbakc")
            callback();
          } catch (err) {
            console.error("[SPEECH CALLBACK] Error:", err);
          }
        }
        if (this._ws && this._ws.readyState === WebSocket.OPEN) {
          this._ws.send(JSON.stringify({
            type: "announcement_completed",
            flow: this._currentFlow,
            uniqueId: this._generateUniqueId()
          }));
        }
        this._awaitingPcmFinish = false;
        if (this._callbacks.onAgentSpeechEnd) {
          this._callbacks.onAgentSpeechEnd();
        }
        if (this._callbacks.onAgentSpeechEndCustom) {
          this._callbacks.onAgentSpeechEndCustom();
        }

        if (window.completedMyraSay) {
          window.completedMyraSay();
        }

        const restartListening = (attempt = 0) => {

          const currentHealth = this._isActuallyListening();
          if (currentHealth.healthy) {
            return;
          }
          const isMac = /Mac/.test(navigator.platform);
          const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
          const platformDelay = (isMac || isSafari) ? 800 : 300;

          this._startListening()
            .then(() => {
              console.log(`[PCM] Successfully restarted listening after agent speech`);
            })
            .catch(error => {
              if (attempt < 3) {
                // Exponential backoff: 1s, 2s, 4s
                const delay = 1000 * Math.pow(2, attempt);
                setTimeout(() => {
                  restartListening(attempt + 1);
                }, delay);
              } else {
                if (this._callbacks.onError) {
                  this._callbacks.onError({
                    code: "LISTENING_RESTART_FAILED",
                    message: "Failed to restart listening after multiple attempts",
                    requiresUserAction: true
                  });
                }
              }
            });
        };
        // Original logic for non-QNA flows
        const status = this._getAudioPlaybackStatus();
        const extraDelay = status.bufferTime > 0 ? Math.min(500, status.bufferTime * 1000) : 300;

        setTimeout(() => {
          restartListening();
        }, extraDelay);
        return;
      }
      setTimeout(poll, 50);
    };
    poll();
    window.forceQuickComplete = poll;
  },
  handleVisibilityRestored() {
    console.log("[VISIBILITY] Page visibility restored");
    if (this._intentionalClose) {
      console.warn("[VISIBILITY] blocked auto");
      return false;
    }
    // if (this._resourceManager) {
    //   const status = this._resourceManager.getStatus();
    //   if (status.monitor?.isHealthy === false) {
    //     console.log("[VISIBILITY] Resource unhealthy, delaying restart");
    //     setTimeout(() => this._maybeReconnect("visibility"), 1000);
    //     return;
    //   }
    // }


    // 1. Check connection status
    const status = this.getConnectionStatus();
    console.log(`[VISIBILITY] Current status: ${status}`);

    // 2. If disconnected, attempt reconnect
    if (status === 'disconnected' || status === 'reconnecting') {
      console.log("[VISIBILITY] Attempting reconnection...");
      this.forceReconnect();
    }

    // 3. If in QnA flow and not listening, restart
    const isQnAFlow = this._isQnAFlow();
    if (isQnAFlow && !this._isListening && this._currentFlow) {
      console.log(`[VISIBILITY] Restarting listening for QnA flow: ${this._currentFlow}`);
      setTimeout(() => {
        if (!this._intentionalClose) {
          this._startListening().catch(err =>
            console.error("[VISIBILITY] Listening restart failed:", err)
          );
        }
      }, 1000);
    }

    // // 4. Send visibility restored to backend
    // if (this._ws && this._ws.readyState === WebSocket.OPEN) {
    //   this._ws.send(JSON.stringify({
    //     type: "visibility_restored",
    //     flow: this._currentFlow,
    //     timestamp: Date.now(),
    //     uniqueId: this._generateUniqueId()
    //   }));
    // }
  },
  _getAudioPlaybackStatus() {
    const player = window.audioPlayer;
    if (!player || !player.pcm) return { isComplete: false };

    const queued = player.pcm.queuedSamples || 0;
    const bufferTime = player.pcm.bufferTime || 0;
    const isActive = player.pcm.active || false;

    // More conservative: wait for buffer to drain AND some silence
    const isComplete = !isActive || (queued === 0 && bufferTime < 0.05);

    return { isComplete, queued, bufferTime, isActive };
  },

  async _playClipUrl(url) {
    const player = window.audioPlayer;
    if (!player?.unlocked) {
      console.log("Audio not unlocked yet; queuing blob URL");
      this._pendingAudioUrls.push(url);
      return;
    }

    try {
      await player.ensureCtxRunning?.();
      await player.playAudio(url);
      this._isPlayingLegacy = true;
    } catch (err) {
      console.error("Error playing blob URL via audioPlayer:", err);
    }
  },

  _flushPendingBlobUrls() {
    if (!window.audioPlayer?.unlocked) return;
    if (this._pendingAudioUrls.length === 0) return;
    console.log(`Flushing ${this._pendingAudioUrls.length} queued blob URLs`);
    const urls = [...this._pendingAudioUrls];
    this._pendingAudioUrls = [];
    urls.forEach((u) => this._playClipUrl(u));
  },

  _abToBlobUrl(arrayBuffer) {
    let mime = "";
    if (arrayBuffer && arrayBuffer.byteLength >= 4) {
      const u8 = new Uint8Array(arrayBuffer.slice(0, 4));
      if (u8[0] === 0x49 && u8[1] === 0x44 && u8[2] === 0x33) mime = "audio/mpeg"; // ID3
      else if (u8[0] === 0x4f && u8[1] === 0x67 && u8[2] === 0x67 && u8[3] === 0x53) mime = "audio/ogg"; // OggS
      else if (u8[0] === 0x1a && u8[1] === 0x45 && u8[2] === 0xdf && u8[3] === 0xa3) mime = "audio/webm"; // EBML
      else if (u8[0] === 0xff && (u8[1] & 0xe0) === 0xe0) mime = "audio/mpeg"; // MP3 frame sync
      else console.log("Unknown audio signature:", `${u8[0]}-${u8[1]}-${u8[2]}-${u8[3]}`);
    }
    const blob = mime ? new Blob([arrayBuffer], { type: mime }) : new Blob([arrayBuffer]);
    return URL.createObjectURL(blob);
  },
  _validateListeningState() {
    const actuallyListening = this._isActuallyListening()?.healthy;
    if (this._isListening && !actuallyListening) {
      console.warn("[STATE_VALIDATION] Listening state inconsistent, correcting...");
      this._isListening = false;
      // Attempt to restart if conditions are met
      if (this._currentFlow && this._ws?.readyState === WebSocket.OPEN) {
        this._startListening().catch((err) =>
          console.error("[STATE_VALIDATION] Failed to correct state:", err));
      }
    }
  },
  // Add a helper method:
  _getBrowserDelay() {
    const _isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const _isEdge = /Edg/.test(navigator.userAgent);
    const _isMac = /Mac/.test(navigator.platform);

    if (_isSafari && _isMac) return 1000; // Safari on Mac needs 1s
    if (_isEdge && _isMac) return 800;    // Edge on Mac needs 800ms
    return 300;                           // Other browsers
  },
  async _startListening() {
    // STEP 1: CONCURRENT START PREVENTION
    if (this._startListeningInProgress) {
      console.warn("[START_LISTENING] Already starting, blocking concurrent attempt");
      return;
    }
    this._startListeningInProgress = true;
    try {
      await this._startListeningInternal();
    } finally {
      // Always release lock
      this._startListeningInProgress = false;
    }
  },
  /**
   * Internal implementation of start listening
   * Separated to ensure lock is always released
   */
  async _startListeningInternal() {
    // STEP 2: HEALTH CHECK - EARLY RETURN IF HEALTHY
    const currentHealth = this._isActuallyListening();

    // updating resource monitor
    // if (this._resourceManager) {
    //   this._resourceManager.saveState({
    //     state: 'listening_active',
    //     flow: this._currentFlow,
    //     timestamp: Date.now()
    //   });
    // }
    if (currentHealth.healthy) {
      console.log("[START_LISTENING] Already healthy, early return");
      // Sync flag if needed
      if (!this._isListening) {
        this._isListening = true;
        if (this._callbacks.onListeningStart) {
          this._callbacks.onListeningStart();
        }
      }
      return;
    }
    // STEP 3: HANDLE ZOMBIE STATE WITH COOLDOWN

    if (currentHealth.isZombie) {
      console.warn("[START_LISTENING] Zombie detected - forcing cleanup");
      // Check if we're in a zombie restart loop
      const now = Date.now();
      if (!this._lastZombieRestart) this._lastZombieRestart = 0;

      // Minimum 3 seconds between zombie restarts
      if (now - this._lastZombieRestart < 3000) {
        console.warn("[START_LISTENING] Zombie restart throttled, skipping");
        return;
      }

      this._lastZombieRestart = now;
      await this._cleanupMediaRecorder();
      await new Promise(r => setTimeout(r, 100));
    }

    // STEP 4: PLATFORM DETECTION (OPTIMIZED)

    const ua = navigator.userAgent;
    const platform = {
      isMobile: /Android|webOS|iPhone|iPad|iPod/i.test(ua),
      isIOS: /iPad|iPhone|iPod/.test(ua) && !window.MSStream,
      isSafari: /^((?!chrome|android).)*safari/i.test(ua),
      isAndroid: /Android/i.test(ua)
    };

    // Platform-specific configuration
    const config = this._getPlatformConfig(platform);

    console.log(`[START_LISTENING] Platform: ${platform.isMobile ? 'Mobile' : 'Desktop'}${platform.isIOS ? ' (iOS)' : platform.isAndroid ? ' (Android)' : ''}${platform.isSafari ? ' (Safari)' : ''}`);

    // STEP 5: INITIALIZE RETRY STATE

    if (!this._retryState) {
      this._retryState = {
        attempts: 0,
        lastAttempt: 0,
        maxAttempts: 999,
        isZombieRestart: false
      };
    }

    // STEP 6: COMPREHENSIVE CLEANUP

    await this._cleanupMediaRecorder();

    // Clear timers
    if (this._listenTimeoutId) {
      clearTimeout(this._listenTimeoutId);
      this._listenTimeoutId = null;
    }

    // Reset counters
    this._debugChunkCount = 0;
    this._emptyChunkCount = 0;

    // STEP 7: PLATFORM-SPECIFIC DELAY

    if (config.initDelay > 0) {
      console.log(`[START_LISTENING] Init delay: ${config.initDelay}ms`);
      await new Promise(r => setTimeout(r, config.initDelay));
    }

    try {
      // STEP 8: AUDIO CONSTRAINTS (OPTIMIZED PER PLATFORM)

      const constraints = this._getAudioConstraints(platform);

      // STEP 9: REQUEST MICROPHONE

      console.log("[START_LISTENING] Requesting microphone...");
      const stream = await navigator.mediaDevices.getUserMedia(constraints);

      console.log(`[START_LISTENING] Stream obtained: ${stream.id}, tracks: ${stream.getAudioTracks().length}`);

      this._cachedStream = stream;

      // Update audio monitor
      if (this._audioMonitor) {
        this._audioMonitor.updateStream(stream);
      }

      // STEP 10: CREATE MEDIA RECORDER

      this._mediaRecorder = this._createMediaRecorder(stream, platform);

      // STEP 11: ENSURE WEBSOCKET READY WITH BACKOFF

      const startD = Date.now();
      while (!this._ensureWebSocketReady()) {
        if (Date.now() - startD > 5000) throw new Error("WS not ready");
        await new Promise(r => setTimeout(r, 100));
      }

      // STEP 12: SETUP EVENT HANDLERS

      this._setupMediaRecorderHandlers(config);

      // STEP 13: START RECORDING WITH TIMEOUT

      console.log(`[START_LISTENING] Starting with ${config.timeslice}ms timeslice...`);


      if (window.deepgramNotActive) { window.deepgramNotActive = false; }

      this._mediaRecorder.start(config.timeslice);

      // Wait for start event with timeout
      await this._waitForRecorderStart(config.startTimeout);

      // STEP 14: VERIFY HEALTH

      await new Promise(r => setTimeout(r, 150));

      const finalHealth = this._isActuallyListening();

      if (!finalHealth.healthy) {
        const errorMsg = `Health check failed: ${JSON.stringify(finalHealth)}`;
        console.error("[START_LISTENING]", errorMsg);
        throw new Error(errorMsg);
      }

      // Success! Reset retry state
      this._retryState.attempts = 0;
      this._retryState.isZombieRestart = false;

      console.log("[START_LISTENING] ✓ Successfully started and verified", {
        isListening: this._isListening,
        recorderState: this._mediaRecorder.state,
        wsState: this._ws?.readyState,
        flow: this._currentFlow
      });

    } catch (error) {
      // STEP 15: ERROR HANDLING WITH EXPONENTIAL BACKOFF

      console.error("[START_LISTENING] Failed:", error.message);

      this._isListening = false;

      if (this._callbacks.onListeningStop) {
        this._callbacks.onListeningStop();
      }

      // Cleanup on error
      await this._cleanupMediaRecorder();

      // Don't retry for permission/support errors
      if (this._isNonRetryableError(error)) {
        console.error(`[START_LISTENING] ${error.name} - not retrying`);

        if (this._callbacks.onError) {
          this._callbacks.onError({
            code: error.name === "NotAllowedError" ? "PERMISSION_DENIED" : "NOT_SUPPORTED",
            message: error.name === "NotAllowedError"
              ? "Microphone access denied"
              : "MediaRecorder not supported",
            error
          });
        }

        // Reset retry state
        this._retryState.attempts = 0;
        return;
      }

      // Handle retry with exponential backoff
      await this._handleRetry(error, platform.isMobile);
    }
  },
  _getPlatformConfig(platform) {
    if (platform.isIOS) {
      return {
        initDelay: 800,
        timeslice: 500,
        startTimeout: 5000,
        emptyChunkTolerance: 15,
        wsBufferLimit: 300_000, // Lower for iOS
        bitrate: 24000
      };
    }

    if (platform.isAndroid) {
      return {
        initDelay: 500,
        timeslice: 400,
        startTimeout: 4000,
        emptyChunkTolerance: 10,
        wsBufferLimit: 400_000,
        bitrate: 32000
      };
    }

    if (platform.isMobile) {
      return {
        initDelay: 500,
        timeslice: 400,
        startTimeout: 4000,
        emptyChunkTolerance: 10,
        wsBufferLimit: 500_000,
        bitrate: 32000
      };
    }

    if (platform.isSafari) {
      return {
        initDelay: 600,
        timeslice: 250,
        startTimeout: 3000,
        emptyChunkTolerance: 8,
        wsBufferLimit: 800_000,
        bitrate: 48000
      };
    }

    // Desktop Chrome/Firefox/Edge
    return {
      initDelay: 200,
      timeslice: 250,
      startTimeout: 2000,
      emptyChunkTolerance: 5,
      wsBufferLimit: 1_000_000,
      bitrate: 64000
    };
  },

  /**
   * Get audio constraints for platform
   */
  _getAudioConstraints(platform) {
    if (platform.isIOS) {
      // iOS: Optimized constraints
      return {
        audio: {
          channelCount: 1,
          echoCancellation: true,
          sampleSize: 16
        }
      };
    }

    if (platform.isSafari) {
      // Safari: Basic constraints
      return {
        audio: {
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: this._isQnAFlow() ? true : false,
          autoGainControl: false
        }
      };
    }

    if (platform.isAndroid) {
      // Android: Mobile-optimized
      return {
        audio: {
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: this._isQnAFlow() ? true : false,
          autoGainControl: true
        }
      };
    }

    if (platform.isMobile) {
      // Other mobile
      return {
        audio: {
          channelCount: 1,
          echoCancellation: true,
          noiseSuppression: this._isQnAFlow() ? true : false,
          autoGainControl: true
        }
      };
    }

    // Desktop: Full quality
    return {
      audio: {
        channelCount: 1,
        echoCancellation: true,
        noiseSuppression: this._isQnAFlow() ? true : false,
        autoGainControl: true,
        sampleRate: 48000,
        sampleSize: 16
      }
    };
  },
  _createMediaRecorder(stream, platform) {
    const config = this._getPlatformConfig(platform);

    return new PcmMediaRecorder(stream, {
      sampleRate: config.bitrate,
      bufferSize: 4096,
    });

    /*
      // Try preferred mimeType, fallback to default
      let mimeType;
      if (!platform.isSafari && !platform.isIOS) {
        mimeType = "audio/webm;codecs=opus";
        if (!MediaRecorder.isTypeSupported(mimeType)) {
          mimeType = undefined;
        }
      }
  
      try {
        const recorder = new MediaRecorder(stream, {
          mimeType,
          audioBitsPerSecond: config.bitrate
        });
  
        console.log(`[START_LISTENING] MediaRecorder created: ${mimeType || 'default'}, ${config.bitrate}bps`);
        return recorder;
      } catch (e) {
        console.warn("[START_LISTENING] Using default MediaRecorder:", e.message);
        return new MediaRecorder(stream, {
          audioBitsPerSecond: config.bitrate
        });
      }
  	
    */
  },
  _shouldSuppressAudio(chunkCount) {
    if (chunkCount <= 10) {
      return false;
    }

    if (this._currentFlow === "start_silent") {
      return true;
    }

    // if ( window.deepgramNotActive ) {
    // 	// Deepgram reconnecting
    // 	console.log('Waiting for disconnect... Chunks');
    // 	return true;
    // }

    // Check authoritative backend state first
    if (this._isAgentSpeaking === true) {
      // Safety check: if agent has been speaking for > 60 seconds, assume state is stuck
      if (this._agentSpeakingStartTime) {
        const speakingDuration = Date.now() - this._agentSpeakingStartTime;
        if (speakingDuration > 1000 * 60 * 5) {
          console.error("[MIC] Agent speaking state stuck for >60s, clearing");
          this._isAgentSpeaking = false;
          this._agentSpeakingStartTime = null;
          return false;
        }
      }
      return true; // Backend says agent is speaking
    }

    // Check UI state (rate-limited to avoid excessive calls)
    const now = Date.now();
    if (now - this._lastAgentSpeakingCheck > 250) { // Check max 4 times per second
      this._lastAgentSpeakingCheck = now;

      try {
        const uiState = window.mayraCode?.getState?.();
        if (uiState?.isAgentSpeaking === true) {
          // UI says speaking but backend state doesn't match - log for debugging
          if (chunkCount % 40 === 0) {
            console.warn("[MIC] UI shows speaking but backend state disagrees - allowing audio through");
          }
          // Trust backend state over UI state
          return false;
        }
      } catch (error) {
        console.error("[MIC] Error checking UI state:", error);
      }
    }

    return false; // Default: don't suppress
  },
  _forceRestartListening() {
    if (this._listeningHealth.isRecovering) {
      console.log("[MIC] Already recovering, skipping restart");
      return;
    }
    this._listeningHealth.isRecovering = true;

    this._stopListening();
    // Waiting for the cleanup
    setTimeout(() => {
      this._startListening()
        .then(() => {
          this._listeningHealth.isRecovering = false;
          this._listeningHealth.consecutiveFailures = 0;
        })
        .catch(err => {
          this._listeningHealth.isRecovering = false;
          const retryDelay = Math.min(5000, 1000 * Math.pow(2, this._listeningHealth.consecutiveFailures));
          setTimeout(() => {
            this._forceRestartListening();
          }, retryDelay);
        });
    }, 1000);
  },
  _setupMediaRecorderHandlers(config) {
    let chunkCount = 0;
    let emptyChunkCount = 0;
    let hasReceivedData = false;
    let lastDataTime = 0;

    this._mediaRecorder.ondataavailable = (event) => {
      chunkCount++;
      this._debugChunkCount = chunkCount;
      if (this._waitingForFirstChunk && event.data.size > 0) {
        this._waitingForFirstChunk = false;
        if (this._firstChunkTimeout) {
          clearTimeout(this._firstChunkTimeout);
          this._firstChunkTimeout = null;
        }

        this._isListening = true;
        this._listeningHealth.lastHealthyCheck = Date.now();
        this._listeningHealth.consecutiveFailures = 0;

        if (this._callbacks.onListeningStart) {
          console.log("[MIC] First valid chunk received - confirmed listening");
          this._callbacks.onListeningStart();
        }
      }

      // Log periodically
      if (chunkCount <= 3 || chunkCount % 30 === 0) {
        // console.log(`[MIC] Chunk #${chunkCount}: ${event.data.size} bytes`);
      }

      // Handle empty chunks with smarter detection
      if (event.data.size === 0) {
        emptyChunkCount++;
        this._emptyChunkCount = emptyChunkCount;

        // Only treat as zombie if:
        // 1. We previously received data
        // 2. We've hit tolerance limit
        // 3. It's not during initial warm-up (first 10 chunks)
        if (hasReceivedData &&
          emptyChunkCount >= config.emptyChunkTolerance &&
          chunkCount > 10) {

          const now = Date.now();
          this._listeningHealth.consecutiveFailures++;
          // Only restart zombies every 5 seconds minimum
          if (!this._lastZombieRestart || (now - this._lastZombieRestart) > 5000) {
            console.error(`[MIC] ZOMBIE: ${emptyChunkCount} empty chunks, scheduling cleanup`);
            this._lastZombieRestart = now;

            // Schedule cleanup, not immediate restart
            setTimeout(() => {
              if (!this._intentionalClose && !this._isListening) {
                console.log("[MIC] Cleaning up zombie state");
                this._resetMediaRecorderState();
              }
            }, 1000);
          }
        }
        return;
      }

      // Valid data received
      emptyChunkCount = 0;
      this._emptyChunkCount = 0;
      hasReceivedData = true;
      lastDataTime = Date.now();
      this._listeningHealth.lastHealthyCheck = Date.now();
      this._listeningHealth.consecutiveFailures = 0;

      // Skip if agent is speaking (except first 10 chunks)
      const shouldSuppressAudio = this._shouldSuppressAudio(chunkCount);
      if (shouldSuppressAudio) {
        // Log occasionally for debugging
        if (chunkCount % 40 === 0) {
          // console.log(`[MIC] Agent speaking - suppressing chunk (speaking for ${Math.round((Date.now() - this._agentSpeakingStartTime) / 1000)}s)`);
        }
        return;
      }

      // Send to WebSocket with smart buffering
      if (this._ws?.readyState === WebSocket.OPEN) {
        event.data.arrayBuffer().then(buffer => {
          window.sendtobackend = true
          if (this._ws?.readyState !== WebSocket.OPEN) return;

          // Dynamic buffer management based on chunk size
          const chunkSize = buffer.byteLength;
          const bufferRatio = this._ws.bufferedAmount / config.wsBufferLimit;

          if (bufferRatio > 0.8 && this._currentFlow !== "flow_plan_v2") {
            if (!this._bufferOverflowState.isOverflowing) {
              this._bufferOverflowState.isOverflowing = true;
              this._bufferOverflowState.overflowStartTime = Date.now();
            }
            const response = this._handleBufferOverflow(bufferRatio, buffer.byteLength);
            if (response === 'drop') {
              console.log('[BUFFER] Dropping chunk (Tier 1)');
              this._bufferOverflowState.chunksDropped++;
              return; // Don't send

            } else if (response === 'delay') {
              const shortDelay = Math.min(300, bufferRatio * 200);
              setTimeout(() => this._ws.send(buffer), shortDelay);

            } else if (response === 'delay_heavy') {
              const heavyDelay = Math.min(1000, 500 + (bufferRatio * 500));
              setTimeout(() => this._ws.send(buffer), heavyDelay);

            } else if (response === 'drop_all') {
              console.log('[BUFFER] Dropping all chunks (restart pending)');
              this._bufferOverflowState.chunksDropped++;
              return;
            }
            // 80% full
            // Calculate delay based on how full buffer is
            // const delay = Math.min(200, bufferRatio * 250);
            // console.warn(`[MIC] Buffer ${Math.round(bufferRatio * 100)}% full, delaying ${delay}ms`);

            // setTimeout(() => {
            //   if (this._ws?.readyState === WebSocket.OPEN) {
            //     this._ws.send(buffer);
            //   }
            // }, delay);
          } else {
            if (this._bufferOverflowState.isOverflowing) {
              this._resetOverflowState();
            }
            this._ws.send(buffer);
          }
        }).catch(err => {
          console.error("[MIC] Failed to process audio chunk:", err);
        });
      }
    };

    this._mediaRecorder.onstop = () => {
      // if (this._isAutoRestart) {
      //   console.log("[MIC] Planned restart");
      //   this._mediaRecorder.start(config.timeslice);
      //   return;
      // }

      console.log("[MIC] Recorder stopped");
      this._isListening = false;
      hasReceivedData = false;

      if (this._callbacks.onListeningStop) {
        this._callbacks.onListeningStop();
      }

      // Notify backend if this was a manual stop
      if (this._ws?.readyState === WebSocket.OPEN && this._currentFlowStopListen) {
        this._ws.send(JSON.stringify({
          type: "stt_end",
          stopFlow: this._currentFlowStopListen
        }));
      }
    };

    this._mediaRecorder.onerror = (e) => {
      console.error("[MIC] Recorder error:", e?.error || e);
      this._isListening = false;
      hasReceivedData = false;

      if (this._callbacks.onListeningStop) {
        this._callbacks.onListeningStop();
      }
    };

    //   // Auto restart to clear memory
    // if (this._isAutoRestartTimer) { clearInterval(this._isAutoRestartTimer); }
    // this._isAutoRestartTimer = setInterval(() => {
    //   if (this._mediaRecorder && this._mediaRecorder.state === "recording") {
    //     this._isAutoRestart = true;
    //     this._mediaRecorder.stop();
    //   }
    // }, 1000 * 60 * 2);

    this._mediaRecorder.onstart = () => {
      // if (this._isAutoRestart) {
      //   console.log("[MIC] Planned restart");
      //   this._isAutoRestart = false;
      //   return;
      // }
      this._waitingForFirstChunk = true;
      this._firstChunkTimeout = setTimeout(() => {
        if (this._waitingForFirstChunk) {
          console.error("[MIC] No data received after start - zombie state");
          this._isListening = false;
          if (this._callbacks.onListeningStop) {
            this._callbacks.onListeningStop();
          }
          // Attempt recovery
          this._resetMediaRecorderState();
          setTimeout(() => this._startListening(), 1000);
        }
      }, 2000);

      console.log("[MIC] Recorder started");
      // this._isListening = true;
      hasReceivedData = false;
      emptyChunkCount = 0;

      // if (this._callbacks.onListeningStart) {
      //   this._callbacks.onListeningStart();
      // }
    };
  },
  _resetOverflowState() {
    this._bufferOverflowState = {
      isOverflowing: false,
      overflowStartTime: 0,
      totalOverflowDuration: 0,
      chunksDropped: 0,
      tier: 0,
      lastActionTime: 0
    };
  },
  _handleBufferOverflow(bufferRatio, chunkSize) {
    const now = Date.now();
    const { tier, overflowStartTime } = this._bufferOverflowState;

    // Calculate overflow duration
    const overflowDuration = now - overflowStartTime;

    // 0-15 seconds (Warning & Light CHUNK Dropping)
    if (overflowDuration < 15000) {
      if (tier < 1) {
        console.warn(`[BUFFER] : Light overflow (${Math.round(overflowDuration / 1000)}s)`);
        this._bufferOverflowState.tier = 1;
      }

      // Droping the 20-40% of chunks 
      const dropRate = 0.2 + (overflowDuration / 15000) * 0.2; // 20% → 40%
      return this._shouldDropChunk(dropRate) ? 'drop' : 'delay';
    }

    // 15-30 seconds (Critical & Aggressive Dropping)
    else if (overflowDuration < 30000) {
      if (tier < 2) {
        console.error(`[BUFFER] Tier 2: Critical overflow (${Math.round(overflowDuration / 1000)}s)`);
        this._bufferOverflowState.tier = 2;
      }

      // Drop 50-80% of chunks
      const severity = (overflowDuration - 15000) / 15000; // 0 to 1
      const dropRate = 0.5 + (severity * 0.3); // 50% -> 80%
      return this._shouldDropChunk(dropRate) ? 'drop' : 'delay_heavy';
    }

    // TIER 3: 30+ seconds (Restart Preparation)
    else {
      if (tier < 3) {
        const userName = localStorage.getItem("self_name") || ""
        console.error(`[BUFFER] Tier 3: Restart required (${Math.round(overflowDuration / 1000)}s)`);
        this._bufferOverflowState.tier = 3;
        // this.startFlow(this._currentFlow, userName)
      }
      return 'drop_all'; // Drop everything while restarting
    }
  },
  // Not randomealy dropping - preserveing the speech intelligibility
  _shouldDropChunk(targetDropRate) {
    const { chunksDropped } = this._bufferOverflowState;

    // Don't drop chunks too close together - preserve speech continuity
    if (this._lastDropTime && Date.now() - this._lastDropTime < 300) {
      return false;
    }

    // Calculate adjusted drop rate
    let adjustedRate = targetDropRate;

    // Adaptive dropping based on speech detection
    if (this._lastTranscriptTime && Date.now() - this._lastTranscriptTime < 2000) {
      // Try to preserve speech chunks - half rate for speech
      adjustedRate = targetDropRate * 0.5;
    }
    // No adjustment for non-speech/silence

    // Determine if we should drop this chunk
    const shouldDrop = Math.random() < adjustedRate;

    // Tracking when we drop
    if (shouldDrop) {
      this._lastDropTime = Date.now();
      this._bufferOverflowState.chunksDropped = (chunksDropped || 0) + 1;
    }
    return shouldDrop;
  },

  /**
   * Wait for MediaRecorder to start with timeout
   */
  async _waitForRecorderStart(timeout) {
    return new Promise((resolve, reject) => {
      const timer = setTimeout(() => {
        reject(new Error("MediaRecorder start timeout"));
      }, timeout);

      const onStart = () => {
        clearTimeout(timer);
        resolve();
      };

      this._mediaRecorder.addEventListener("start", onStart, { once: true });
    });
  },

  /**
   * Check if error is non-retryable
   */
  _isNonRetryableError(error) {
    return error.name === "NotAllowedError" ||
      error.name === "PermissionDeniedError" ||
      error.name === "NotSupportedError" ||
      error.name === "SecurityError";
  },

  /**
   * Handle retry logic with exponential backoff
   */
  async _handleRetry(error, isMobile) {
    // Increment retry attempts
    this._retryState.attempts++;
    this._retryState.lastAttempt = Date.now();

    // Check max attempts
    if (this._retryState.attempts >= this._retryState.maxAttempts) {
      console.error(`[START_LISTENING] Max retries (${this._retryState.maxAttempts}) exceeded`);

      if (this._callbacks.onError) {
        this._callbacks.onError({
          code: "MAX_RETRIES_EXCEEDED",
          message: "Failed to start listening after multiple attempts",
          error: error.message
        });
      }

      // Reset for future attempts
      this._retryState.attempts = 0;
      return;
    }

    // Calculate exponential backoff with jitter
    const baseDelay = isMobile ? 3000 : 2000;
    const backoffDelay = Math.min(
      baseDelay * Math.pow(2, this._retryState.attempts - 1),
      10000 // Max 10 seconds
    );

    // Add jitter (±20%)
    const jitter = backoffDelay * 0.2 * (Math.random() - 0.5);
    const finalDelay = Math.min(Math.max(500, backoffDelay + jitter), 30000);

    console.log(`[START_LISTENING] Retry ${this._retryState.attempts}/${this._retryState.maxAttempts} in ${Math.round(finalDelay)}ms`);

    // Schedule retry
    setTimeout(() => {
      if (!this._intentionalClose && !this._isListening && !this._startListeningInProgress) {
        console.log("[START_LISTENING] Executing retry attempt");
        this._startListening().catch(retryError => {
          console.error("[START_LISTENING] Retry failed:", retryError.message);
        });
      }
    }, finalDelay);
  },

  /**
   * Comprehensive MediaRecorder cleanup
   */
  async _cleanupMediaRecorder() {
    if (!this._mediaRecorder) return;

    console.log("[CLEANUP] Cleaning MediaRecorder...");

    try {
      // Stop recorder if active
      if (this._mediaRecorder.state === "recording" ||
        this._mediaRecorder.state === "paused") {
        console.log(`[CLEANUP] Stopping recorder (state: ${this._mediaRecorder.state})`);

        // Create promise for stop event
        const stopPromise = new Promise(resolve => {
          this._mediaRecorder.addEventListener("stop", resolve, { once: true });
        });

        this._mediaRecorder.stop();

        // Wait for stop or timeout
        await Promise.race([
          stopPromise,
          new Promise(resolve => setTimeout(resolve, 300))
        ]);
      }

      // Remove all event listeners
      this._mediaRecorder.ondataavailable = null;
      this._mediaRecorder.onstop = null;
      this._mediaRecorder.onerror = null;
      this._mediaRecorder.onstart = null;

      // Clean up stream tracks
      const stream = this._mediaRecorder.stream;
      if (stream?.getTracks) {
        const tracks = stream.getTracks();
        console.log(`[CLEANUP] Stopping ${tracks.length} track(s)`);

        tracks.forEach(track => {
          if (track.readyState === "live") {
            try {
              track.stop();
              track.enabled = false;
            } catch (e) {
              // Ignore errors during cleanup
            }
          }
        });
      }

    } catch (error) {
      console.warn("[CLEANUP] Error during cleanup:", error);
    }

    // Nullify reference
    this._mediaRecorder = null;

    // Also clean cached stream
    if (this._cachedStream) {
      try {
        const tracks = this._cachedStream.getTracks();
        tracks.forEach(track => {
          if (track.readyState === "live") {
            track.stop();
          }
        });
      } catch (e) {
        console.warn("[CLEANUP] Error cleaning cached stream:", e);
      }
      this._cachedStream = null;
    }

    console.log("[CLEANUP] Complete");
  },
  // Add this helper method
  _getSupportedMimeType() {
    const mimeTypes = ["audio/webm;codecs=opus", "audio/ogg;codecs=opus", "audio/webm", "audio/mp4", ""];

    for (const mimeType of mimeTypes) {
      if (!mimeType || MediaRecorder.isTypeSupported(mimeType)) {
        console.log(`[MIMETYPE] Using: ${mimeType || "browser default"}`);
        return mimeType || undefined;
      }
    }

    console.warn("[MIMETYPE] No specific mimeType supported, using default");
    return undefined;
  },

  _stopListening() {
    console.log(`[STOP_LISTENING] State - isListening: ${this._isListening}, MediaRecorder state: ${this._mediaRecorder?.state}`);
    if (this._firstChunkTimeout) {
      clearTimeout(this._firstChunkTimeout);
      this._firstChunkTimeout = null;
    }
    this._waitingForFirstChunk = false;

    if (!this._isActuallyListening()?.healthy && this._mediaRecorder?.state !== "recording") {
      console.log("[STOP_LISTENING] Already stopped, skipping");
      return;
    }

    if (!this._isListening && (!this._mediaRecorder || this._mediaRecorder.state !== "recording")) {
      console.log("[STOP_LISTENING] Already stopped, skipping");
      return;
    }
    // if (!this._isListening) return;

    console.log("Stop listening", this._currentFlow);

    this._currentFlowStopListen = this._currentFlow;

    if (this._listenTimeoutId) {
      clearTimeout(this._listenTimeoutId);
      this._listenTimeoutId = null;
    }

    if (this._mediaRecorder && this._mediaRecorder.state === "recording") {
      console.log("[STOP_LISTENING] Stopping MediaRecorder, state:", this._mediaRecorder.state);
      try {
        this._mediaRecorder.stop();
      } catch (stopError) {
        console.error("[STOP_LISTENING] Error stopping MediaRecorder:", stopError);
      }
    }
    this._isListening = false;
    if (this._callbacks.onListeningStop) {
      this._callbacks.onListeningStop();
    }
  },
  _resetMediaRecorderState() {
    console.log("[RESET_STATE] Resetting MediaRecorder state");
    this._isListening = false;
    this._emptyChunkCount = 0;

    if (this._mediaRecorder) {
      try {
        if (this._mediaRecorder.state === "recording") {
          console.log("[RESET_STATE] Stopping active MediaRecorder");
          this._mediaRecorder.stop();
        }
      } catch (e) {
        console.warn("[RESET_STATE] Error stopping MediaRecorder:", e);
      }

      // Clean up stream tracks
      try {
        const oldStream = this._mediaRecorder.stream;
        if (oldStream?.getTracks) {
          oldStream.getTracks().forEach((t) => {
            try {
              if (t.readyState === "live") {
                t.stop();
              }
            } catch (_) { }
          });
        }
      } catch (e) {
        console.warn("[RESET_STATE] Error cleaning up stream:", e);
      }
    }

    this._mediaRecorder = null;
  },

  stopAgentSpeech() {
    // Stop any ongoing TTS playback
    try {
      if (window.audioPlayer?.ttsPcmAbort) window.audioPlayer.ttsPcmAbort();
    } catch (error) {
      console.warn("Error stopping PCM playback:", error);
    }

    // Clear any pending audio URLs
    this._pendingAudioUrls.forEach((url) => {
      try {
        URL.revokeObjectURL(url);
      } catch (_) { }
    });
    this._pendingAudioUrls = [];
  },

  forceStop() {
    this.stopAgentSpeech();
    this._stopListening();

    // Send message to backend to stop any ongoing processing
    if (this._ws && this._ws.readyState === WebSocket.OPEN) {
      this._ws.send(JSON.stringify({ type: "stt_end", stopFlow: this._currentFlowStopListen, forceStop: 1 }));
    }
  },
  stopAllVoiceActivity() {
    console.log("[VoiceService] Stopping all voice activity");
    // Stop any TTS playback
    if (window.audioPlayer?.ttsPcmAbort) {
      window.audioPlayer.ttsPcmAbort();
    }
    // Clear any pending audio URLs
    this._pendingAudioUrls.forEach((url) => {
      try {
        URL.revokeObjectURL(url);
      } catch (_) { }
    });
    this._pendingAudioUrls = [];
  },
  _generateUniqueId() {
    return Math.random().toString(36).slice(2) + Date.now().toString(36);
  },
  async destroyMyraCompletely(sendtoBackend = true) {
    console.log("[DESTROY] HARD shutdown started - ensuring microphone released");

    sessionStorage.removeItem("voiceService_wasListening");
    sessionStorage.removeItem("voiceService_currentFlow");
    sessionStorage.removeItem("voiceService_lastFlow");
    localStorage.removeItem("voiceService_reconnectFlow");

    // RESET ALL CALLBACKS
    this._callbacks.onConnected = () => { };
    this._callbacks.onAgentSpeechEndCustom = () => { };
    this._callbacks.onNluResult = () => { };
    this._intentionalClose = true;
    this._shouldReconnect = false;
    this._isListening = false;
    this._currentFlow = null;
    this._connected = false;
    this._connecting = false;

    // removing resoruce monitor on destroy;
    // if (this._resourceManager && this._resourceManager._monitoringStarted) {
    //   this._resourceManager.stopMonitoring();
    //   this._resourceManager._monitoringStarted = false;
    // }
    // if (this._resourceManager) {
    //   this._resourceManager.shutdown({
    //     mediaRecorder: this._mediaRecorder,
    //     audioContext: window.audioPlayer?.context
    //   });
    // }

    // 2. IMMEDIATELY stop any ongoing audio monitoring
    if (this._audioMonitor) {
      try {
        this._audioMonitor.disable();
        this._audioMonitor.stop();
      } catch (_) { }
      this._audioMonitor = null;
    }

    // 3. Clear ALL timers FIRST
    this._clearHeartbeat();
    this._clearPongTimer();

    if (this._listenTimeoutId) {
      clearTimeout(this._listenTimeoutId);
      this._listenTimeoutId = null;
    }

    if (this._connectionMonitor) {
      clearInterval(this._connectionMonitor);
      this._connectionMonitor = null;
    }

    if (this._zombieCheckInterval) {
      clearInterval(this._zombieCheckInterval);
      this._zombieCheckInterval = null;
    }

    // 4. STOP MEDIA RECORDER - MORE AGGRESSIVE
    if (this._mediaRecorder) {
      try {
        console.log(`[DESTROY] MediaRecorder state: ${this._mediaRecorder.state}`);

        // Store stream before anything else
        const stream = this._mediaRecorder.stream;

        // Force stop if recording
        if (this._mediaRecorder.state === "recording") {
          console.log("[DESTROY] Force stopping MediaRecorder");
          try {
            this._mediaRecorder.stop();
          } catch (e) {
            console.warn("[DESTROY] Error in MediaRecorder.stop():", e);
          }
        }

        // Remove all event handlers
        this._mediaRecorder.ondataavailable = null;
        this._mediaRecorder.onstop = null;
        this._mediaRecorder.onerror = null;
        this._mediaRecorder.onstart = null;

        // Stop stream tracks if exists
        if (stream && stream.getTracks) {
          const tracks = stream.getTracks();
          console.log(`[DESTROY] Stopping ${tracks.length} tracks from MediaRecorder stream`);

          tracks.forEach(track => {
            try {
              track.stop();
              track.enabled = false;
              console.log(`[DESTROY] Stopped track: ${track.kind} (${track.label})`);
            } catch (error) {
              console.warn(`[DESTROY] Could not stop track:`, error);
            }
          });
        }

        // Nullify MediaRecorder
        this._mediaRecorder = null;

      } catch (error) {
        console.error("[DESTROY] Error in MediaRecorder cleanup:", error);
        this._mediaRecorder = null;
      }
    }

    // 5. Stop cached stream tracks
    if (this._cachedStream && this._cachedStream.getTracks) {
      try {
        const tracks = this._cachedStream.getTracks();
        console.log(`[DESTROY] Stopping ${tracks.length} tracks from cached stream`);

        tracks.forEach(track => {
          try {
            track.stop();
            track.enabled = false;
            console.log(`[DESTROY] Stopped cached track: ${track.kind} (${track.label})`);
          } catch (error) {
            console.warn(`[DESTROY] Could not stop cached track:`, error);
          }
        });
      } catch (error) {
        console.error("[DESTROY] Error stopping cached stream:", error);
      }
      this._cachedStream = null;
    }

    // 6. CLEAN WEBSOCKET - PREVENT RECONNECTS
    if (this._ws) {
      try {
        // Remove ALL event handlers first
        this._ws.onopen = null;
        this._ws.onmessage = null;
        this._ws.onerror = null;
        this._ws.onclose = null;

        // Send destroy message if needed
        if (sendtoBackend && this._ws.readyState === WebSocket.OPEN) {
          try {
            this._ws.send(JSON.stringify({
              type: "destroy_myra",
              uniqueId: this._generateUniqueId(),
              permanent: true  // Tell backend not to expect reconnection
            }));
            // Wait for message to be sent
            await new Promise(resolve => setTimeout(resolve, 100));
          } catch (_) { }
        }

        // Close WebSocket with special code
        if (this._ws.readyState !== WebSocket.CLOSED &&
          this._ws.readyState !== WebSocket.CLOSING) {
          this._ws.close(4999, "PERMANENT_SHUTDOWN"); // Custom close code
        }
      } catch (_) { }

      this._ws = null;
    }

    // 7. Stop all voice activity
    try {
      this.stopAllVoiceActivity();
    } catch (_) { }

    // 8. Clean up memory
    this._pendingAudioUrls.forEach(url => {
      try { URL.revokeObjectURL(url); } catch (_) { }
    });
    this._pendingAudioUrls = [];
    this._pcmBuffer = null;

    // 10. MICROPHONE RELEASE
    console.log("[DESTROY] Starting aggressive microphone release");

    // 11. Reset all state
    this._resetAllState();
    this._isListening = false;
    this._currentFlow = null;
    this._connected = false;
    this._connecting = false;
    this._reconnectAttempts = 0;
    this._shouldReconnect = true;
    this._shouldReconnect = false;

    // Clear any session storage flags
    sessionStorage.removeItem("voiceService_wasListening");
    sessionStorage.removeItem("voiceService_currentFlow");

    // 12. Final wait
    console.log("[DESTROY] Finalizing...");
    await new Promise(resolve => setTimeout(resolve, 1000));

    if (this._listenersBound) {
      document.removeEventListener("visibilitychange", this._visibilityHandler);
      window.removeEventListener("online", this._onlineHandler);
      this._listenersBound = false;
    }

    console.log("[DESTROY] HARD shutdown complete - PERMANENT");
    return true;
  },
  async _verifyMicFullyReleased({ timeoutMs = 800, retries = 2 } = {}) {
    if (!navigator.mediaDevices?.getUserMedia) return true;

    for (let i = 0; i < retries; i++) {
      try {
        const stream = await Promise.race([
          navigator.mediaDevices.getUserMedia({ audio: true }),
          new Promise((_, r) => setTimeout(() => r(new Error("timeout")), timeoutMs))
        ]);

        stream.getTracks().forEach(t => {
          try { t.stop(); } catch (_) { }
        });

        console.log("[MIC VERIFY] Mic fully released");
        return true;
      } catch {
        await new Promise(r => setTimeout(r, 120));
      }
    }

    console.warn("[MIC VERIFY] Mic may still be locked (Chrome GC delay)");
    return false;
  },

  _resetAllState() {
    this._cachedStream = null;
    this._pendingAudioUrls = [];
    this._isPlayingLegacy = false;
    this._awaitingPcmFinish = false;
    this._debugChunkCount = 0;
    this._pcmBuffer = null;
    this._listenTimeoutId = null;
    this._currentFlowStopListen = null;
    this._lastReceivedId = null;
    this._lastCallTime = 0;

    // Clear all timers
    if (this._heartbeatTimer) clearInterval(this._heartbeatTimer);
    if (this._pongTimer) clearTimeout(this._pongTimer);

    this._heartbeatTimer = null;
    this._pongTimer = null;

    // this._isListening = false;
    // this._currentFlow = null;
    // this._connected = false;
    // this._connecting = false;
    // this._reconnectAttempts = 0;
    // this._shouldReconnect = true;
  },

  setHelpState(helpDataArray) {
    if (!this._ws || this._ws.readyState !== WebSocket.OPEN) {
      console.error("WebSocket is not connected. Cannot set help state.");
      return false;
    }

    try {
      this._ws.send(
        JSON.stringify({
          type: "set_help_state",
          helpData: helpDataArray, // Array: [state, context]
        })
      );
      return true;
    } catch (error) {
      console.error("Error setting help state:", error);
      return false;
    }
  },

  _cleanup() {
    this._stopListening();
    this._resetMediaRecorderState();
    this._ws = null;
    this._pendingAudioUrls.forEach((u) => {
      try {
        URL.revokeObjectURL(u);
      } catch (_) { }
    });
    this._pendingAudioUrls = [];
    this._isPlayingLegacy = false;
    this._awaitingPcmFinish = false;

    // NEW: clear heartbeat timers
    this._clearHeartbeat();
    this._clearPongTimer();
    if (this._connectionTimeoutId) {
      clearTimeout(this._connectionTimeoutId);
      this._connectionTimeoutId = null;
    }
    if (this._zombieCheckInterval) {
      clearInterval(this._zombieCheckInterval);
      this._zombieCheckInterval = null;
    }
  },

  // --- NEW: Minimal reconnect + heartbeat helpers ---
  _startConnectionMonitor() {
    // Clear any existing monitor
    if (this._connectionMonitor) {
      clearInterval(this._connectionMonitor);
      this._connectionMonitor = null;
    }

    // Only start if we should be connected
    if (!this._shouldReconnect) return;

    // Check connection status periodically
    this._connectionMonitor = setInterval(() => {
      // If we're supposed to be connected but we're not, try to reconnect
      if (this._shouldReconnect &&
        !this._connecting &&
        !this._connected &&
        navigator.onLine) {

        console.log('[CONNECTION MONITOR] Attempting to reconnect...');
        this._connect();
      }
    }, 5000); // Check every 5 seconds
  },
  _connect() {
    if (this._connecting) {
      // If we've been "connecting" for more than 10 seconds, it's a bug/stuck state. Reset it.
      if (Date.now() - (this._connectionStartTime || 0) > 10000) {
        this._connecting = false;
      } else {
        return;
      }
    }
    if (!this._url) return;
    // if (!this._shouldReconnect && this._ws) return;
    if (this._ws && this._ws.readyState === WebSocket.OPEN) return;

    this._connecting = true;
    this._connectionStartTime = Date.now();
    const isAndroid = /Android/i.test(navigator.userAgent);
    if (isAndroid && this._connecting && this._ws?.readyState === WebSocket.CONNECTING) {
      const stuckTime = Date.now() - (this._connectionStartTime || 0);
      if (stuckTime > 15000) { // 15 seconds stuck
        console.warn("[ANDROID] Stuck in connecting for", stuckTime, "ms, forcing cleanup");
        this._cleanup();
        this._connecting = false;
      }
    }

    // Platform detection
    const ua = navigator.userAgent;
    const isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(ua);
    const isIOS = /iPad|iPhone|iPod/.test(ua);
    const isSafari = /^((?!chrome|android).)*safari/i.test(ua);
    const isReconnection = this._hasConnectedBefore;

    // Store whether we were listening before disconnect - ENHANCE THIS
    const wasListening = this._isListening;
    const previousFlow = this._currentFlow;

    // Store in persistent storage for reconnection
    sessionStorage.setItem("voiceService_wasListening", wasListening.toString());
    sessionStorage.setItem("voiceService_currentFlow", previousFlow || "");

    // Cleaning up the existing connection
    if (this._ws) {
      try {
        this._ws.close();
      } catch { }
      this._ws = null;
    }

    // this._ws = new WebSocket("ws://localhost:8080/ws/tts");
    this._ws = new WebSocket(this._url);
    this._ws.binaryType = "arraybuffer";

    // Mobile/Safari connection timeout (shorter for mobile)
    const connectionTimeout = isAndroid ? 8000 : isMobile ? 10000 : 20000;
    this._connectionTimeoutId = setTimeout(() => {
      if (this._ws && this._ws.readyState === WebSocket.CONNECTING) {
        console.warn(`[CONNECT] Timeout after ${connectionTimeout}ms`);
        this._ws.close(); // This will trigger onclose logic
        this._connecting = false;
      }
    }, connectionTimeout);

    this._ws.onopen = () => {
      if (this._connectionTimeoutId) {
        clearTimeout(this._connectionTimeoutId);
        this._connectionTimeoutId = null;
      }
      console.log("Connected to backend WebSocket");
      this._connecting = false;
      this._connected = true;
      // if (this._resourceManager && !this._resourceManager._monitoringStarted) {
      //   this._resourceManager.startMonitoring();
      //   this._resourceManager._monitoringStarted = true;
      //   console.log("[Resource Monitoring] : started")
      // }
      this._reconnectAttempts = 0;
      this._startConnectionMonitor();
      const isReconnection = this._hasConnectedBefore;
      this._hasConnectedBefore = true;


      // RESTORE LISTENING STATE - ENHANCED VERSION
      const wasListening = sessionStorage.getItem("voiceService_wasListening") === "true";
      const previousFlow = sessionStorage.getItem("voiceService_currentFlow");

      // STEP 1: CREATE MONITOR - WebSocket connects
      if (!this._audioMonitor) {
        this._audioMonitor = new MyraAudioMonitor({
          websocket: this._ws, // Pass the connected WebSocket
        });

        // STEP 2: START IT
        this._audioMonitor.start().then((success) => {
          if (success) {
            console.log("[AUDIO MONITOR] Started successfully");
          }
        });

        window.monitorStopMyra = this._audioMonitor.stop;
        window.monitorStopMyraStream = this._audioMonitor.stopStream;
      }
      if (isReconnection && previousFlow) {
        const reconnectDelay = isMobile ? 1500 : 1000;
        console.log("Restarting flow after disconnect")
        setTimeout(() => {
          const userName = window.localStorage.getItem("self_name") || "";
          const flowToRestart = previousFlow || this._currentFlow;
          if (!this._ws || this._ws.readyState !== WebSocket.OPEN) {
            console.warn("[RECONNECT] WebSocket not ready");
            return;
          }
          this._ws.send(JSON.stringify({
            type: "start_flow",
            flow: flowToRestart,
            startName: userName
          }));
          window.currentFlow = flowToRestart;
          this._currentFlow = flowToRestart;
          setTimeout(() => {
            const currentHealth = this._isActuallyListening();
            if (!currentHealth.healthy) {
              console.log("[RECONNECT] Starting listening");
              this._startListening().catch(err => {
                setTimeout(() => {
                  this._startListening().catch(e =>
                    console.error("[RECONNECT] Retry also failed:", e)
                  );
                }, 2000);
              });
            } else {
              console.log("[RECONNECT] Already listening, no action needed");
            }
          }, 1000);
        }, reconnectDelay);
      }
      // FIX: Restart listening if we were listening before disconnect
      if (wasListening && previousFlow) {
        console.log(`[RECONNECT] Restarting listening for flow: ${previousFlow}`);
        // Clear any existing timeout
        if (this._listenTimeoutId) {
          clearTimeout(this._listenTimeoutId);
          this._listenTimeoutId = null;
        }

        setTimeout(() => {
          this._startListening().catch((err) => {
            console.error("[RECONNECT] Failed to restart listening:", err);
            // Retry with backoff
            setTimeout(() => {
              this._startListening().catch((e) => console.error("[RECONNECT] Retry failed:", e));
            }, 2000);
          });
        }, 1000);
      }

      if (this._callbacks.onConnected) {
        this._callbacks.onConnected();
      }
      // start heartbeat after successful open
      this._startHeartbeat();
      // optional hello/keepalive
      try {
        this._ws.send(JSON.stringify({ type: "hello", ts: Date.now() }));
      } catch { }
    };

    this._ws.onclose = () => {
      console.log("Disconnected from backend WebSocket");
      if (this._connectionTimeoutId) {
        clearTimeout(this._connectionTimeoutId);
        this._connectionTimeoutId = null;
      }
      this._connected = false;
      this._connecting = false;
      // if (this._resourceManager && this._resourceManager._monitoringStarted) {
      //   this._resourceManager.stopMonitoring();
      //   this._resourceManager._monitoringStarted = false;
      // }
      this._cleanup();
      // this._scheduleReconnect("close");
      if (navigator.onLine) {
        console.log("[CONNECT] Connection lost but Online. Retrying in 2s...");
        setTimeout(() => this.forceReconnect(), 2000);
      } else {
        console.log("[CONNECT] Device Offline. Waiting for network event...");
      }
      // this._startConnectionMonitor();
      // Also schedule immediate reconnect attempt
      // if (this._shouldReconnect && navigator.onLine) {
      //   const delay = this._backoffDelay();
      //   this._reconnectAttempts += 1;
      //   setTimeout(() => this._connect(), delay);
      // }
    };

    this._ws.onerror = (error) => {
      console.error("WebSocket error:", error);
      // errors often precede close; let onclose drive reconnect/backoff
    };

    this._ws.onmessage = (event) => {
      this._handleBackendMessage(event);
    };
  },
  _safeStartListeningMobile() {
    if (this._intentionalClose) {
      console.log("[SAFE_START] Intentional close, skipping");
      return;
    }

    if (!this._ws || this._ws.readyState !== WebSocket.OPEN) {
      console.warn("[SAFE_START] WebSocket not open, state:", this._ws?.readyState);
      return;
    }

    console.log("[SAFE_START] Starting listening...");

    // Clear any existing timeout
    if (this._listenTimeoutId) {
      clearTimeout(this._listenTimeoutId);
      this._listenTimeoutId = null;
    }

    this._startListening().catch((error) => {
      console.error("[SAFE_START] Failed to start listening:", error);

      // Platform detection for retry
      const ua = navigator.userAgent;
      const isMobile = /Android|webOS|iPhone|iPad|iPod/i.test(ua);
      const isSafari = /^((?!chrome|android).)*safari/i.test(ua);

      // Mobile/Safari retry
      if ((isMobile || isSafari) && !this._intentionalClose) {
        console.log("[SAFE_START] Mobile/Safari retry in 2 seconds...");
        setTimeout(() => {
          if (!this._intentionalClose && this._ws && this._ws.readyState === WebSocket.OPEN) {
            this._startListening().catch(e =>
              console.error("[SAFE_START] Retry failed:", e)
            );
          }
        }, 2000);
      }
    });
  },

  _maybeReconnect(trigger) {
    if (!this._shouldReconnect || this._intentionalClose) return;
    if (this._ws && (this._ws.readyState === WebSocket.OPEN || this._ws.readyState === WebSocket.CONNECTING)) return;
    if (this._connecting) return;
    if (!navigator.onLine) return;
    this._connect();
  },
  forceReconnect() {
    console.log('[FORCE RECONNECT] Manually triggered');
    this._connecting = false;
    this._shouldReconnect = true;
    this._intentionalClose = false;
    this._connect();
  },

  _backoffDelay() {
    const base = 1000; // 1s
    const exp = Math.min(10, this._reconnectAttempts);
    const raw = Math.min(this._maxBackoffMs, base * Math.pow(2, exp));
    const jitter = Math.floor(Math.random() * 1000);
    return raw + jitter;
  },

  _scheduleReconnect(reason) {
    if (!this._shouldReconnect) return;
    if (!navigator.onLine) {
      // will try again when 'online' fires
      return;
    }
    const delay = this._backoffDelay();
    this._reconnectAttempts += 1;
    setTimeout(() => this._connect(), delay);
  },

  _startHeartbeat() {
    this._clearHeartbeat();
    this._bumpPongTimer(); // expect activity soon
    this._heartbeatTimer = setInterval(() => {
      try {
        if (this._ws && this._ws.readyState === WebSocket.OPEN) {
          console.log("PING SENT");
          this._ws.send(JSON.stringify({ type: "ping", ts: Date.now() }));
          this._bumpPongTimer();
        }
      } catch { }
    }, this._pingIntervalMs);
  },

  _clearHeartbeat() {
    if (this._heartbeatTimer) {
      clearInterval(this._heartbeatTimer);
      this._heartbeatTimer = null;
    }
  },

  _bumpPongTimer() {
    this._clearPongTimer();
    this._pongTimer = setTimeout(() => {
      // no messages in too long: force-close to trigger reconnect path
      if (this._ws && this._ws.readyState === WebSocket.OPEN) {
        try {
          console.warn("Closing WS due to timeout pong");
          this._ws.close();
        } catch { }
      }
    }, this._pongTimeoutMs);
  },

  _clearPongTimer() {
    if (this._pongTimer) {
      clearTimeout(this._pongTimer);
      this._pongTimer = null;
    }
  },
};

window.MyraAudioMonitor = {
  getStatus: () => (VoiceService._audioMonitor ? VoiceService._audioMonitor.getHealth() : null),
  forceReconnect: () => (VoiceService._audioMonitor ? VoiceService._audioMonitor.forceReconnect() : Promise.resolve(false)),
  isMonitoring: () => (VoiceService._audioMonitor ? VoiceService._audioMonitor.isMonitoring : false),
};

window.VoiceService = VoiceService;
window.getVoiceServiceHealth = () => VoiceService.getListeningHealth();

export default VoiceService;
